// Generated by build/translations/export_thervumitra.py from IndicTrans2 output:
// ThervuMitra UI strings for languages without human translations.
// Do not edit by hand; fix the source strings in i18n.js and regenerate.
export default {
  "ta": {
    "about": "பற்றி",
    "agreeNote": "இந்த படிவத்தை அனுப்புவதன் மூலம் நீங்கள் எங்கள் {privacy} மற்றும் {terms} ஐ ஒப்புக்கொள்கிறீர்கள்.",
    "anAsk": "கேளுங்கள்",
    "anAskError_budget": "AI அதன் தினசரி வரம்பை எட்டியுள்ளது. தயவுசெய்து நாளை மீண்டும் முயற்சிக்கவும்.",
    "anAskError_incomplete": "பதில் முழுமையடையவில்லை. தயவுசெய்து கேள்வியை மறுபிரசுரம் செய்து மீண்டும் முயற்சிக்கவும்.",
    "anAskError_limit": "குறுகிய காலத்தில் நீங்கள் பல கேள்விகளைக் கேட்டுள்ளீர்கள். தயவுசெய்து சிறிது நேரம் காத்திருந்து மீண்டும் முயற்சிக்கவும்.",
    "anAskError_question": "தயவுசெய்து ஒரு நீண்ட கேள்வியை எழுதுங்கள்.",
    "anAskError_unavailable": "AI இப்போது பதிலளிக்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
    "anAskIntroCourse": "இந்தப் பாடத்திட்டத்தைப் பற்றி உங்கள் சொந்த வார்த்தைகளில் கேளுங்கள்: ஈடுபாடு, முன்னேற்றம், தரங்கள், கடினமான தலைப்புகள், ஆபத்தில் உள்ள கற்பவர்கள். AI உங்களுக்கான வரைபடங்களை உருவாக்குகிறது.",
    "anAskIntroPlatform": "முழு தளத்தைப் பற்றியும் உங்கள் சொந்த வார்த்தைகளில் கேளுங்கள்: வளர்ச்சி, படிப்புகள், கற்பவர்கள், நிறைவு மற்றும் விற்பனை. AI உங்களுக்கான விளக்கப்படங்களை உருவாக்குகிறது.",
    "anAskPlaceholder": "எ. கா. எந்த வினாடி வினா பாடத்தில் கற்பவர்கள் அதிக சிரமப்படுகிறார்கள்?",
    "anAskTitle": "உங்கள் கற்றல் தரவைப் பற்றி AI ஐக் கேளுங்கள்",
    "anCannotAnswer": "இந்தக் கேள்விக்குப் பதிலளிக்கக் கூடிய கற்றல் தரவுகள் கிடைக்கவில்லை.",
    "anChartType": "விளக்கப்பட வகை",
    "anClear": "தெளிவான உரையாடல்",
    "anCourse": "பாடத்திட்டம்",
    "anCourseTable": "பாடத்திட்ட செயல்திறன்",
    "anCsv": "CSV என பதிவிறக்கவும்",
    "anExC1": "கடந்த இரண்டு மாதங்களில் ஒவ்வொரு வாரமும் எத்தனை மாணவர்கள் சுறுசுறுப்பாக இருந்தனர்?",
    "anExC2": "எந்தெந்த பிரச்சினைகள் மிகக் குறைந்த சராசரி மதிப்பெண் கொண்டவை?",
    "anExC3": "பாடத்திட்டத்தில் மாணவர்கள் எங்கு இடைநிறுத்தப்படுகிறார்கள்?",
    "anExC4": "இரண்டு வாரங்களாக சுறுசுறுப்பாக இல்லாத ஆபத்தில் உள்ள கற்பவர்களை பட்டியலிடுங்கள்",
    "anExP1": "கடந்த 3 மாதங்களில் எந்தெந்த பிரிவுகள் அதிக அளவில் வளர்ந்துள்ளன?",
    "anExP2": "படிப்புகளில் தேர்ச்சி விகிதங்களை ஒப்பிடுக",
    "anExP3": "இந்த ஆண்டு ஒவ்வொரு மாதமும் எத்தனை புதிய மாணவர்கள் பதிவு செய்தனர்?",
    "anExP4": "இந்த மாதம் எந்தெந்த படிப்புகள் அதிகம் விற்பனை செய்யப்பட்டன?",
    "anIntro": "உங்கள் கேள்விகளுக்கான பதில்களுடன், கற்றவர்கள் எவ்வாறு சேர்கிறார்கள், படிப்பார்கள் மற்றும் செயல்படுவார்கள் என்பது குறித்த விளக்கப்படங்கள் மற்றும் அறிக்கைகள்.",
    "anKpi_active_week": "இந்த வாரம் செயலில் உள்ளது",
    "anKpi_at_risk": "ஆபத்தில் உள்ள மாணவர்கள்",
    "anKpi_avg_grade": "சராசரி தரம்",
    "anKpi_avg_progress": "சராசரி முன்னேற்றம்",
    "anKpi_certificates": "சான்றிதழ்கள்",
    "anKpi_enrolled": "பதிவு செய்யப்பட்ட மாணவர்கள்",
    "anKpi_enrollments": "பதிவுபெற்றவர்கள்",
    "anKpi_new_users": "புதிய பயனர்கள் (30 நாட்கள்)",
    "anKpi_new_week": "இந்த வாரம் புதிதாக",
    "anKpi_pass_rate": "தேர்ச்சி விகிதம்",
    "anKpi_rating": "மதிப்பீடு",
    "anKpi_revenue_month": "விற்பனை (30 நாட்கள்)",
    "anKpi_users": "பதிவுசெய்யப்பட்ட பயனர்கள்",
    "anLink": "பகுப்பாய்வு",
    "anLoadError": "பகுப்பாய்வு பதிவேற்ற முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
    "anLoading": "உங்கள் டாஷ்போர்டைத் தயாரித்துக் கொண்டிருக்கிறீர்கள்...",
    "anMore": "{n} மேலும் காட்டப்படவில்லை.",
    "anNoAccess": "பாடத்திட்ட பயிற்றுவிப்பாளர்கள், பாடத்திட்ட ஊழியர்கள் மற்றும் தள ஊழியர்களுக்கு பகுப்பாய்வு கிடைக்கிறது. நீங்கள் இன்னும் எந்த பாடத்திட்டத்தையும் கற்பிக்கவில்லை.",
    "anNoAccessCourse": "இந்த பாடத்திட்டத்தின் பகுப்பாய்வுக்கான அணுகல் உங்களுக்கு இல்லை.",
    "anNoData": "இது குறித்த தகவல் இன்னும் இல்லை.",
    "anOverview": "கண்ணோட்டம்",
    "anPickCourse": "ஒரு பாடத்திட்டத்தைத் தேர்ந்தெடுக்கவும்",
    "anPin": "டாஷ்போர்டில் பின் செய்யவும்",
    "anPinned": "பின்னப்பட்ட",
    "anPinnedTitle": "உங்கள் பின்னப்பட்ட அறிக்கைகள்",
    "anPlatform": "முழு மேடையும்",
    "anPrivacy": "AI தரவு புலங்கள் மற்றும் ஒருங்கிணைந்த முடிவுகளின் பெயர்களை மட்டுமே பார்க்கிறது, ஒருபோதும் கற்றவரின் பெயர்கள் அல்லது மின்னஞ்சல்கள் இல்லை.",
    "anRefresh": "புத்துணர்ச்சி பெறுங்கள்",
    "anRep_active_daily": "ஒரு நாளைக்கு சுறுசுறுப்பான கற்றவர்கள்",
    "anRep_activity_mix": "வாரத்திற்கு கற்றல் செயல்பாடு",
    "anRep_age": "வயது அடிப்படையில் கற்றவர்கள்",
    "anRep_assess_scores": "வினாடி வினா அல்லது பணி மூலம் சராசரி மதிப்பெண்",
    "anRep_at_risk": "ஆபத்தில் உள்ள மாணவர்கள்",
    "anRep_by_category": "வகைப்படி பதிவு",
    "anRep_country": "நாடு வாரியாக கற்கும் மாணவர்கள்",
    "anRep_education": "கல்வியின் மூலம் கற்றவர்கள்",
    "anRep_enroll_trend": "வாரத்திற்கு ஒரு முறை பதிவு",
    "anRep_funnel": "ஒவ்வொரு பிரிவையும் அடையும் மாணவர்கள்",
    "anRep_gender": "பாலினம் அடிப்படையில் கற்றவர்கள்",
    "anRep_grade_dist": "தரப் பகிர்வு",
    "anRep_hardest": "மிகவும் கடினமான பிரச்சினைகள்",
    "anRep_mastery": "கருத்தியல் தேர்ச்சி",
    "anRep_pass_rates": "படிப்பு படி தேர்ச்சி விகிதம்",
    "anRep_ratings": "மதிப்பீடுகள்",
    "anRep_registrations": "வாரத்திற்கு புதிய பதிவுகள்",
    "anRep_revenue": "மாதாந்திர விற்பனை",
    "anRep_revenue_items": "சிறந்த விற்பனையான படிப்புகள் மற்றும் திட்டங்கள்",
    "anRep_risk": "இடைநிறுத்தம் ஏற்படும் ஆபத்து",
    "anRep_top_courses": "சேர்க்கை அடிப்படையில் சிறந்த படிப்புகள்",
    "anRep_weekday": "மாணவர்கள் படிக்கும்போது",
    "anReportError": "இந்த அறிக்கையைத் தயாரிக்க முடியவில்லை.",
    "anScope": "பகுப்பாய்வுகளைக் காட்டு",
    "anThinking": "தரவுகளைப் பகுப்பாய்வு செய்தல்...",
    "anTitle": "கற்றல் பகுப்பாய்வு",
    "anTruncated": "மிக சமீபத்திய பதிவுகளின் அடிப்படையில் மட்டுமே.",
    "anUnpin": "அகற்றவும்",
    "anUpdated": "{time} இல் புதுப்பிக்கப்பட்டது",
    "anView_area": "பகுதி",
    "anView_bar": "பார்கள்",
    "anView_donut": "டோனட்",
    "anView_hbar": "தரவரிசைப்படுத்தப்பட்ட பட்டைகள்",
    "anView_line": "வரிசை",
    "anView_number": "எண்",
    "anView_pie": "பை",
    "anView_stacked": "அடுக்கி வைக்கப்பட்ட பட்டைகள்",
    "anView_table": "மேஜை",
    "assistantBudget": "உதவியாளர் இன்று ஓய்வெடுக்கிறார். தயவுசெய்து பாடத்திட்டப் பட்டியலை உலாவவும் அல்லது எங்களைத் தொடர்பு கொள்ளவும்.",
    "assistantClose": "அரட்டை மூடு",
    "assistantDisclaimer": "செயற்கை நுண்ணறிவு பதில்கள் தவறாக இருக்கலாம். பாடத்திட்டப் பக்கத்தில் முக்கியமான விவரங்களைச் சரிபார்க்கவும்.",
    "assistantGreeting": "வணக்கம்! ThervuMitra பற்றிய படிப்புகளைக் கண்டுபிடித்து கேள்விகளுக்கு பதிலளிக்க நான் உங்களுக்கு உதவ முடியும். நீங்கள் என்ன கற்றுக்கொள்ள விரும்புகிறீர்கள்?",
    "assistantLimit": "குறுகிய காலத்தில் நீங்கள் நிறைய கேள்விகளைக் கேட்டுள்ளீர்கள். தயவுசெய்து சிறிது நேரத்திற்குப் பிறகு மீண்டும் முயற்சிக்கவும்.",
    "assistantNew": "புதிய அரட்டை",
    "assistantOpen": "ThervuMitra ஐக் கேளுங்கள்",
    "assistantPlaceholder": "உங்கள் கேள்வியை தட்டச்சு செய்யுங்கள்...",
    "assistantSearching": "அதை மேலே பாருங்கள்...",
    "assistantSend": "அனுப்பவும்",
    "assistantSuggest1": "நான் எந்தெந்த படிப்புகளை எடுக்கலாம்?",
    "assistantSuggest2": "நான் எப்படி மொழியை மாற்றுவது?",
    "assistantSuggest3": "படிப்புகள் சான்றிதழ்களை வழங்குகின்றனவா?",
    "assistantSuggest4": "நான் எப்படி உங்களைத் தொடர்பு கொள்ள முடியும்?",
    "assistantThinking": "யோசித்துக் கொண்டிருக்கிறார்...",
    "assistantTitle": "ThervuMitra உதவியாளர்",
    "assistantUnavailable": "உதவியாளர் இப்போது கிடைக்கவில்லை. தயவுசெய்து பின்னர் மீண்டும் முயற்சிக்கவும் அல்லது எங்களைத் தொடர்பு கொள்ளவும்.",
    "authPoint": "இன்று நாம் புதிதாக ஒன்றைக் கற்றுக்கொள்வோம்!",
    "authSubtitle": "எந்தவொரு சாதனத்திலும் ஒவ்வொரு ThervuMitra பாடத்திற்கும் ஒரு கணக்கு.",
    "authTitle": "எங்கள் கற்றல் சமூகத்திற்கு வரவேற்கிறோம்",
    "backToBlog": "வலைப்பதிவுக்குத் திரும்பு",
    "benefitCertificateText": "நீங்கள் கற்றுக்கொண்டதை நீங்கள் பகிர்ந்து கொள்ளக்கூடிய சான்றிதழின் மூலம் காட்டுங்கள்.",
    "benefitCertificateTitle": "சான்றிதழ்களைப் பெறுங்கள்",
    "benefitOpenText": "ஒரு கணக்கை உருவாக்கி, சில நிமிடங்களில் கற்றுக்கொள்ளத் தொடங்குங்கள்.",
    "benefitOpenTitle": "அனைவருக்காகவும் திறந்திருக்கும்",
    "benefitPaceText": "எந்த நேரத்திலும், எந்த சாதனத்திலும், உங்களுக்கு பொருத்தமான வேகத்தில் படியுங்கள்.",
    "benefitPaceTitle": "உங்கள் சொந்த வேகத்தில் கற்றுக்கொள்ளுங்கள்",
    "benefitPartnersText": "நமது பங்குதாரர் நிறுவனங்களால் வடிவமைக்கப்பட்டு கற்பிக்கப்படும் படிப்புகள்.",
    "benefitPartnersTitle": "நம்பகமான நிறுவனங்களிலிருந்து படிப்புகள்",
    "blog": "வலைப்பதிவு",
    "blogSubtitle": "ThervuMitra குழுவிலிருந்து செய்திகள், கதைகள் மற்றும் கற்றல் உதவிக்குறிப்புகள்.",
    "blogTitle": "ThervuMitra வலைப்பதிவு",
    "builderAddSection": "பிரிவைச் சேர்க்கவும்",
    "builderAddSubsection": "உட்பிரிவு சேர்க்கவும்",
    "builderAddToCourse": "AI உடன் சேர்க்கவும்",
    "builderAddUnit": "அலகு சேர்க்கவும்",
    "builderAnother": "புதிய பாடத்திட்டத்தைத் தொடங்குங்கள்",
    "builderAudience": "அது யாருக்காக?",
    "builderAudiencePlaceholder": "எடுத்துக்காட்டாக: முதல் ஆண்டு கல்லூரி மாணவர்கள்",
    "builderBuild": "{units} அலகுகளை உருவாக்குங்கள்",
    "builderBuildConfirm": "இப்பொழுது பாடத்திட்டத்தை உருவாக்குங்கள்? AI என்பது Studio இல் {units} அலகுகளை எழுதும். இதற்கு சிறிது நேரம் ஆகலாம்.",
    "builderCatalogLevel": "அட்டவணை நிலை",
    "builderCategory": "அட்டவணை வகை",
    "builderChooseCourse": "ஒரு பாடத்திட்டத்தைத் தேர்ந்தெடுக்கவும்...",
    "builderCreating": "Studio இல் பிரிவுகள் மற்றும் அலகுகளை உருவாக்குதல்...",
    "builderDone": "உங்கள் படிப்பு தயாராக உள்ளது",
    "builderDoneNote": "உள்ளடக்கம் Studio இல் உள்ளது, ஆனால் வெளியிடப்படவில்லை. அதை மறுபரிசீலனை செய்து, உங்களுக்குத் தேவையானதைத் திருத்துங்கள், தயாராக இருக்கும்போது வெளியிடுங்கள்.",
    "builderDraft": "அவுட்லைனை வரைவு செய்யுங்கள்",
    "builderDraftNote": "நீங்கள் அவுட்லைனை அங்கீகரிக்கும் வரை Studio இல் எதுவும் சேர்க்கப்படாது.",
    "builderError": "ஏதோ தவறு நடந்துவிட்டது. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
    "builderExam": "இறுதிப் பரீட்சை",
    "builderExistingNote": "ஏற்கனவே உள்ளவற்றுக்குப் பிறகு புதிய பிரிவுகள் சேர்க்கப்படுகின்றன. ஏற்கனவே பாடத்திட்டத்தில் எதுவும் மாற்றப்படவில்லை.",
    "builderFailed": "கட்டிடம் நிறுத்தப்பட்டது",
    "builderFeedback": "அல்லது ஒரு புதிய வரைவைக் கேளுங்கள்",
    "builderFeedbackPlaceholder": "எடுத்துக்காட்டாக: குறைவான பிரிவுகள், அதிக கைகளில் எடுத்துக்காட்டுகள், வரிகள் மீது ஒரு பகுதியை சேர்க்கவும்.",
    "builderHow1": "பாடத்திட்டத்தை விவரிக்கவும்: தலைப்பு, கற்றவர்கள், நிலை மற்றும் மொழி.",
    "builderHow2": "அவுட்லைனை மறுபரிசீலனை செய்யுங்கள். பெயர் மாற்றவும், மறுசீரமைக்கவும், எதையும் சேர்க்கவும் அல்லது அகற்றவும் அல்லது புதிய வரைவைக் கேட்கவும்.",
    "builderHow3": "அதை உருவாக்குங்கள். AI ஒவ்வொரு பிரிவின் பாட உரை மற்றும் வினாடி வினா கேள்விகளை எழுதுகிறது.",
    "builderHow4": "Studio இல் உள்ள உள்ளடக்கத்தை சரிபார்த்து, உங்களுக்குத் தேவையானதைத் திருத்தி, தயாராக இருக்கும்போது வெளியிடவும்.",
    "builderHowTitle": "இது எப்படி வேலை செய்கிறது?",
    "builderIntro": "ஒரு பாடத்திட்டத்தை விவரிக்கவும், நீங்கள் மதிப்பாய்வு செய்ய ஒரு வரைவிலக்கை AI வரைவு செய்கிறது. பின்னர் அது பாடங்களை எழுதுகிறது மற்றும் வினாடி வினா நேராக Studio இல் எழுதுகிறது.",
    "builderKey_number": "பாடத்திட்டம் எண்",
    "builderKey_org": "அமைப்பு",
    "builderKey_run": "பாடத்திட்டம் ஓட்டம்",
    "builderKind": "உட்பிரிவு வகை",
    "builderKind_exam": "பரீட்சை",
    "builderKind_lesson": "பாடம்",
    "builderKind_quiz": "வினாடி வினா",
    "builderLanguage": "பாடத்தின் மொழி",
    "builderLessons": "ஒவ்வொரு பிரிவுக்கும் பாடங்கள்",
    "builderLevel": "நிலை",
    "builderLevel_advanced": "மேம்பட்ட",
    "builderLevel_beginner": "தொடக்கக்காரர்",
    "builderLevel_intermediate": "இடைநிலை",
    "builderMoveDown": "கீழே நகர்த்தவும்",
    "builderMoveUp": "மேலே நகர்த்தவும்",
    "builderNewSection": "புதிய பிரிவு",
    "builderNewSubsection": "புதிய உட்பிரிவு",
    "builderNewUnit": "புதிய அலகு",
    "builderOpenCourse": "Studio இல் திறக்கவும்",
    "builderOutlineIntro": "நீங்கள் விரும்பும் எதையும் திருத்துங்கள். ஒவ்வொரு அலகு உரை மற்றும் பயிற்சி கேள்வியுடன் ஒரு பாடமாக மாறும்; வினாடி வினா மற்றும் தேர்வு உட்பிரிவுகள் தரப்படுத்தப்பட்ட கேள்விகளைப் பெறுகின்றன.",
    "builderOutlining": "உங்கள் வரைவிலக்கை வரைவதற்கு...",
    "builderOutliningNote": "இதற்கு வழக்கமாக ஒரு நிமிடத்திற்கும் குறைவான நேரம் எடுக்கும். நீங்கள் இந்தப் பக்கத்தை விட்டு வெளியேறி பின்னர் திரும்பி வரலாம்.",
    "builderPageTitle": "AI பாடநெறி உருவாக்குநர்",
    "builderProgress": "{total} அலகுகளில் எழுதப்பட்ட {done}",
    "builderProgressNote": "நீங்கள் இந்தப் பக்கத்தை விட்டு வெளியேறலாம்; கட்டுமானம் தொடர்கிறது.",
    "builderPrompt": "பாடத்திட்டத்தில் என்ன கற்பிக்க வேண்டும்?",
    "builderPromptPlaceholder": "எடுத்துக்காட்டாக: இந்தியாவில் உள்ள கல்லூரி மாணவர்களுக்கான தனிப்பட்ட நிதி பற்றிய அறிமுகம்: பட்ஜெட், சேமிப்பு, யுபிஐ பாதுகாப்பு, வரிகள் மற்றும் முதலீட்டு அடிப்படைகள். நடைமுறை, அன்றாட உதாரணங்களுடன்.",
    "builderQuizzes": "ஒவ்வொரு பிரிவின் முடிவிலும் ஒரு தரப்படுத்தப்பட்ட வினாடி வினா",
    "builderRecent": "உங்கள் சமீபத்திய வரைவுகள்",
    "builderRedraft": "மறுவடிவமைப்பு",
    "builderRemove": "அகற்றவும்",
    "builderRetry": "மீண்டும் முயற்சிக்கவும்",
    "builderSave": "அவுட்லைனை சேமிக்கவும்",
    "builderSaved": "சேமித்த",
    "builderSection": "பிரிவு",
    "builderSectionTitle": "பிரிவின் தலைப்பு",
    "builderSections": "பிரிவுகள்",
    "builderShortDescription": "சுருக்கமான விளக்கம்",
    "builderStatus_building": "கட்டிடம்",
    "builderStatus_done": "கட்டப்பட்டது",
    "builderStatus_failed": "தோல்வியடைந்தார்",
    "builderStatus_outline_ready": "வரைவிலக்கு தயார்",
    "builderStatus_outlining": "வரைவமைப்பு வரைவிலக்கு",
    "builderStep1": "1. உங்கள் பாடத்திட்டத்தை விவரிக்கவும்",
    "builderStep2": "2. அவுட்லைனை மறுபரிசீலனை செய்யுங்கள்",
    "builderStep3": "3. பாடத்திட்டத்தை உருவாக்குவது",
    "builderSubsectionTitle": "உட்பிரிவு தலைப்பு",
    "builderTarget": "அது எங்கே போக வேண்டும்?",
    "builderTargetExisting": "நான் ஏற்கனவே வைத்திருக்கும் பாடத்திட்டத்தில் சேர்க்கவும்",
    "builderTargetNew": "ஒரு புதிய பாடத்திட்டத்தை உருவாக்குங்கள்",
    "builderTitle": "பாடத்திட்டத்தின் தலைப்பு",
    "builderTopics": "தலைப்புகள் ({max} வரை)",
    "builderUnitGoal": "கற்றவர் எதை எடுத்துச் செல்ல வேண்டும்",
    "builderUnitTitle": "அலகு தலைப்பு",
    "builderWorking": "தொடக்கம்...",
    "catalogTitle": "படிப்புகளை ஆராயுங்கள்",
    "chooseLanguage": "உங்கள் மொழியைத் தேர்ந்தெடுக்கவும்",
    "cmAddConcept": "கருத்தைச் சேர்க்கவும்",
    "cmAddConceptToUnit": "கருத்தைச் சேர்க்கவும்",
    "cmAddPrereq": "முன்நிபந்தனைகளைச் சேர்க்கவும்",
    "cmAddQuestion": "கேள்வியைச் சேர்க்கவும்",
    "cmAiDraft": "செயற்கை நுண்ணறிவு வரைவு, இன்னும் மதிப்பாய்வு செய்யப்படவில்லை",
    "cmApprove": "சேமித்து ஒப்புதல் அளியுங்கள்",
    "cmApproved": "அங்கீகரிக்கப்பட்டது",
    "cmBackToCourse": "பாடத்திட்டத்தின் வெளிப்பாட்டிற்குத் திரும்பு",
    "cmButton": "கருத்து வரைபடம்",
    "cmChoice": "தேர்வு {n}",
    "cmConcept": "கருத்துரு",
    "cmConceptName": "கருத்தின் பெயர்",
    "cmCorrect": "சரியான பதில்",
    "cmDenied": "அதன் கருத்தியல் வரைபடத்தைத் திருத்த நீங்கள் பாடத்திட்டக் குழுவில் இருக்க வேண்டும்.",
    "cmDescription": "இந்த கருத்தை அறிந்திருப்பதன் அர்த்தம் என்ன?",
    "cmDraft": "செயற்கை நுண்ணறிவுடன் வரைவு",
    "cmDrafting": "செயற்கை நுண்ணறிவு கருத்தாக்க வரைபடத்தை உருவாக்குகிறது...",
    "cmDraftingNote": "இது வழக்கமாக ஒரு நிமிடத்திற்கும் குறைவாக எடுக்கும். நீங்கள் இந்தப் பக்கத்தை விட்டு வெளியேறலாம்.",
    "cmEmptyText": "AI பாடத்திட்டம் வெளியிடப்பட்ட சில நிமிடங்களுக்குப் பிறகு தானாகவே ஒன்றை வரைகிறது, அல்லது நீங்கள் இப்போது அதை வரைவு செய்யலாம்.",
    "cmEmptyTitle": "கருத்து வரைபடம் இன்னும் இல்லை",
    "cmExplanation": "காசோலைக்குப் பிறகு காட்டப்பட்ட விளக்கம்",
    "cmGraded": "தரப்படுத்தப்பட்டது",
    "cmIntro": "தகவமைப்பு கற்றல் இந்த வரைபடத்தைப் பயன்படுத்தி ஒவ்வொரு கற்பவரும் எதில் தேர்ச்சி பெற்றுள்ளார் என்பதைக் கண்காணிக்கவும், அலகுகளை பரிந்துரைக்கவும், எதைத் தவிர்க்க வேண்டும் என்பதை பரிந்துரைக்கவும், திருத்தத்தைத் தூண்டவும் பயன்படுத்துகிறது.",
    "cmNewConcept": "புதிய கருத்து",
    "cmNoCourse": "பாடத்திட்டத்தின் வெளிப்புறத்திலிருந்து இந்தப் பக்கத்தைத் திறக்கவும்.",
    "cmPrereqs": "கட்டமைக்கிறது:",
    "cmQuestion": "கேள்வி",
    "cmRedraft": "AI உடன் மறுவடிவமைப்பு",
    "cmRedraftConfirm": "இந்த வரைபடத்தை ஒரு புதிய செயற்கை நுண்ணறிவு வரைவு கொண்டு மாற்றவும்? அதில் உங்கள் திருத்தங்கள் இழக்கப்படும்.",
    "cmRefresh": "அலகு பட்டியலை புதுப்பிக்கவும்",
    "cmReviewedBy": "{user} ஆல் மதிப்பாய்வு செய்யப்பட்டது",
    "cmSave": "வரைவைச் சேமிக்கவும்",
    "cmStale": "இந்த வரைபடம் மதிப்பாய்வு செய்யப்பட்டதிலிருந்து பாடநெறி மாறிவிட்டது.",
    "cmTab_concepts": "கருத்துக்கள்",
    "cmTab_diagnostic": "நோயறிதல்",
    "cmTab_units": "அலகுகள்",
    "cmTitle": "கருத்து வரைபடம்",
    "codeLabel": "நாட்டின் குறியீடு",
    "consentLabel": "ThervuMitra இலிருந்து படிப்புகள் மற்றும் நிகழ்வுகள் பற்றிய செய்திகளை எனக்கு அனுப்புங்கள்.",
    "contactError": "ஏதோ தவறு நடந்துவிட்டது. தயவுசெய்து மீண்டும் முயற்சிக்கவும், அல்லது {email} என்ற எண்ணில் எங்களுக்கு எழுதுங்கள்.",
    "contactHeading": "நாங்கள் உதவ இங்கே இருக்கிறோம்",
    "contactIntro": "ஒரு பாடத்திட்டத்தைப் பற்றி உங்களுக்கு கேள்வி இருந்தாலும், உங்கள் நிறுவனத்திற்கு ThervuMitra ஐக் கொண்டு வர விரும்பினாலும், அல்லது எங்களைப் பற்றி கருத்து தெரிவிக்க விரும்பினாலும், உங்களிடமிருந்து கேட்க விரும்புகிறோம்.",
    "contactPromise": "உங்கள் விவரங்களை விடுங்கள், எங்கள் குழு இரண்டு வேலை நாட்களுக்குள் பதிலளிக்கும்.",
    "contactThanks": "நன்றி! உங்கள் செய்தியை நாங்கள் பெற்றோம், விரைவில் உங்களைத் தொடர்புகொள்வோம்.",
    "contactTitle": "எங்களைத் தொடர்பு கொள்ளுங்கள்",
    "contentOriginal": "அசல் காட்டுகிறது. இந்த அலகு {language} இல் கிடைக்கிறது.",
    "contentTranslated": "இந்த அலகு இயந்திரத்தால் {language} என்று மொழிபெயர்க்கப்பட்டுள்ளது.",
    "contentTranslatedNote": "தானியங்கி மொழிபெயர்ப்பில் தவறுகள் இருக்கலாம்.",
    "countryLabel": "நாடு",
    "courseLabel": "நீங்கள் எந்தப் பாடத்திட்டத்தில் ஆர்வம் காட்டுகிறீர்கள்?",
    "dashAccount": "கணக்கு அமைப்புகள்",
    "dashExploreText": "பங்குதாரர் நிறுவனங்களிலிருந்து திறந்த படிப்புகளை உலாவவும்.",
    "dashExploreTitle": "உங்கள் அடுத்த பாடத்திட்டத்தைக் கண்டறியவும்",
    "dashHello": "வணக்கம், {name}!",
    "dashProfile": "சுயவிவரத்தைக் காண்க",
    "dashText": "நீங்கள் விட்டுச் சென்ற இடத்தைத் தேர்ந்தெடுங்கள் அல்லது புதிதாகக் கற்றுக்கொள்ள ஏதாவது ஒன்றைக் கண்டறியவும்.",
    "diagChecking": "சரிபார்க்கப்படுகிறது...",
    "diagIntro": "உங்களால் முடிந்த பதில்களைத் தாருங்கள்: {count} கேள்விகள், பாடத்திட்டத்தின் ஒரு முக்கிய யோசனைக்கு ஒன்று. அது தரப்படுத்தப்படவில்லை. உங்களுக்கு பதில் தெரியாவிட்டால், அதை காலியாக விடுங்கள்.",
    "diagLater": "ஒருவேளை பின்னர்",
    "diagRetake": "அதை மீண்டும் எடுத்துக் கொள்ளுங்கள்",
    "diagRight": "சரிதான்.",
    "diagScore": "உங்களுக்கு {total} இன் {score} கிடைத்தது",
    "diagScoreNote": "உங்கள் பாதை இப்போது நீங்கள் தவிர்க்கக்கூடிய அலகுகளையும், முதலில் வேலை செய்ய இடைவெளிகளையும் பரிந்துரைக்கிறது.",
    "diagSeePath": "என் பாதையைப் பாருங்கள்",
    "diagSkipNote": "உங்கள் பதில்கள் உங்கள் பாதையை மட்டுமே தனிப்பயனாக்குகின்றன; அவை உங்கள் தரத்தை நோக்கி கணக்கிடப்படுவதில்லை.",
    "diagStart": "காசோலையைத் தொடங்குங்கள்",
    "diagSubmit": "எனது பதில்களைச் சரிபார்க்கவும் ({total} இன் {answered})",
    "diagTitle": "அறிவுச் சரிபார்ப்பு",
    "diagWrong": "பதில்: {answer}",
    "emailLabel": "மின்னஞ்சல்",
    "enquiries": "விசாரணைகள்",
    "explore": "படிப்புகளை ஆராயுங்கள்",
    "facetPricing": "விலை",
    "footerCompany": "கம்பெனி",
    "footerContact": "எங்களைத் தொடர்பு கொள்ளுங்கள்",
    "footerLearn": "கற்றுக் கொள்ளுங்கள்",
    "footerLegal": "சட்டப்படி",
    "generalQueries": "பொதுவான கேள்விகள்",
    "getStarted": "தொடங்குங்கள்",
    "gmAchievements": "சாதனைகள்",
    "gmActiveQuests": "செயலில் உள்ள தேடல்கள்",
    "gmAutoFreeze": "நான் ஒரு நாள் தவறவிட்டால் தானாகவே ஒரு ஸ்ட்ரீக் ஃப்ரீஸைப் பயன்படுத்தவும் (உங்களிடம் {tokens} உள்ளது).",
    "gmAvatar": "உங்கள் அவதாரம்",
    "gmBadges": "பேட்ஜ்கள்",
    "gmBadgesOf": "{total} பேட்ஜ்களில் {earned} சம்பாதிக்கப்பட்டது",
    "gmBestDay": "சிறந்த நாள்",
    "gmBestWeek": "சிறந்த வாரம்",
    "gmBoardEmpty": "இந்த லீடர்போர்டில் இன்னும் யாரும் இல்லை.",
    "gmBoard_course": "பாடத்திட்டம்",
    "gmBoard_global": "எல்லா நேரமும்",
    "gmBoard_weekly": "இந்த வாரம்",
    "gmCourses": "படிப்புகள் நடைபெற்று வருகின்றன",
    "gmDailyDone": "அன்றாட இலக்கு நிறைவேறியது!",
    "gmDailyDoneText": "நல்ல வேலை. இன்று வேறு எதுவும் போனஸ்.",
    "gmDailyGoal": "தினசரி இலக்கு",
    "gmDailyGoalSetting": "தினசரி இலக்கு",
    "gmDailyLeft": "{xp} எக்ஸ்பி இன்றைய இலக்கை அடைய.",
    "gmDays": "எம், டி, டபிள்யூ, டி, எஃப், எஸ், எஸ்",
    "gmDaysN": "{n} நாட்கள்",
    "gmEarnedOn": "சம்பாதித்தவர் {date}",
    "gmGo": "போ",
    "gmGoal_100": "தீவிரமானது · {xp} XP",
    "gmGoal_150": "தீவிரம் · {xp} XP",
    "gmGoal_30": "சாதாரண · {xp} XP",
    "gmGoal_60": "வழக்கமான · {xp} XP",
    "gmGoals": "இலக்குகள்",
    "gmHair_bun": "பன்",
    "gmHair_curly": "சுருள்",
    "gmHair_long": "நீளமானது",
    "gmHair_none": "இல்லை",
    "gmHair_ponytail": "போனிடைல்",
    "gmHair_short": "சுருக்கமாக",
    "gmHide": "மறைக்கவும்",
    "gmKind_assessment": "சவால்",
    "gmKind_course": "பாடத்திட்டம்",
    "gmKind_daily": "தினசரி",
    "gmKind_mission": "பணி",
    "gmKind_subject": "பொருள்",
    "gmKind_weekly": "வாராந்திர",
    "gmKindsNote_assessment": "வினாடி வினாக்கள் மற்றும் தேர்வுகள் மூலம் உங்களைச் சோதிக்கவும்.",
    "gmKindsNote_course": "ஒரு குறிப்பிட்ட பாடத்திட்டத்திற்கு.",
    "gmKindsNote_daily": "ஒவ்வொரு நாளும் புதிதாக.",
    "gmKindsNote_mission": "அடுத்த கட்டத்தைத் திறக்க படிகளை முடிக்கவும்.",
    "gmKindsNote_subject": "அனைத்து பாடப்பிரிவுகளிலும் ஒரே பாடத்தில்.",
    "gmKindsNote_weekly": "ஒவ்வொரு திங்கட்கிழமையும் புதிதாக.",
    "gmKinds_assessment": "மதிப்பீட்டு சவால்கள்",
    "gmKinds_course": "பாடநெறி தேடல்கள்",
    "gmKinds_daily": "தினசரி தேடல்",
    "gmKinds_mission": "பணி",
    "gmKinds_subject": "பொருள் சவால்கள்",
    "gmKinds_weekly": "வாராந்திர தேடல்",
    "gmLeaderboard": "தலைமைப் பலகைகள்",
    "gmLevel": "நிலை",
    "gmLevelN": "நிலை {level}",
    "gmLevelProgress": "அடுத்த கட்டத்திற்கு முன்னேறுதல்",
    "gmLevelUp": "நிலை உயர்த்தவும்! நீங்கள் நிலை {level} ஐ அடைந்துவிட்டீர்கள்.",
    "gmLongest": "மிக நீளமானது {n}",
    "gmLongestStreak": "மிக நீளமான வரிசை",
    "gmLook_background": "பின்னணி",
    "gmLook_hair": "முடி",
    "gmLook_hair_color": "முடி நிறம்",
    "gmLook_outfit": "உடைகள்",
    "gmLook_skin": "தோல்",
    "gmMastery": "கருத்தியல் தேர்ச்சி",
    "gmMasteryOf": "{total} இன் {mastered} தேர்ச்சி பெற்றது",
    "gmNickname": "புனைப்பெயர்",
    "gmNicknameInvalid": "3 முதல் 30 எழுத்துக்கள், எண்கள், இடைவெளிகள், புள்ளிகள் அல்லது டாஷ்களைப் பயன்படுத்தவும்.",
    "gmNicknamePlaceholder": "எடுத்துக்காட்டாக: கோட் டைகர்",
    "gmNicknameRequired": "லீடர்போர்டுகளில் சேர ஒரு புனைப்பெயரைத் தேர்ந்தெடுக்கவும்.",
    "gmNoBadges": "பேட்ஜ் பெற உங்கள் முதல் பாடத்தை முடிக்கவும்.",
    "gmNoCourses": "எக்ஸ்பி சம்பாதிக்க ஒரு பாடத்திட்டத்தில் சேருங்கள்.",
    "gmNoQuests": "தற்போது செயலில் உள்ள தேடல்கள் எதுவும் இல்லை.",
    "gmNoRecs": "நீங்கள் அனைவரும் சிக்கிக் கொண்டீர்கள். ஒரு புதிய பாடத்திட்டத்தை ஆராயுங்கள்!",
    "gmNoXp": "நீங்கள் சம்பாதிக்கும் எக்ஸ்பி இங்கே காண்பிக்கப்படும்.",
    "gmNone": "இல்லை",
    "gmOptIn": "தலைசிறந்த பலகைகளில் சேருங்கள்",
    "gmOptInText": "உங்களுக்கு விருப்பமான புனைப்பெயரின் கீழ் தலைப்புப் பலகைகளில் காட்டுங்கள். உங்கள் உண்மையான பெயர் ஒருபோதும் காட்டப்படாது.",
    "gmPercent": "{percent}% நிறைவடைந்தது",
    "gmPersonalBests": "தனிப்பட்ட சிறந்த",
    "gmPrivacy": "உங்கள் புனைப்பெயர், நிலை, அவதாரம் மற்றும் எக்ஸ்பி மட்டுமே மற்றவர்களுக்குக் காட்டப்படுகின்றன.",
    "gmRank": "தரவரிசை",
    "gmRecGoal": "இன்றைய இலக்கை அடைய {xp} அதிக எக்ஸ்பி சம்பாதிக்கவும்.",
    "gmRecNext": "அடுத்து {course}: {unit}.",
    "gmRecPath": "உங்கள் கற்றல் பாதை ஒரு புதிய பாடத்திட்டத்தை பரிந்துரைக்கிறது.",
    "gmRecQuest": "{quest}: {left} + {xp} XP க்கு செல்ல.",
    "gmRecRevise": "{concept} ஐ {course} இல் திருத்துங்கள்.",
    "gmRecentAchievements": "சமீபத்திய சாதனைகள்",
    "gmRecommended": "அடுத்ததாக பரிந்துரைக்கப்பட்டது",
    "gmRemindGoal": "{xp} எக்ஸ்பி இன்றைய இலக்கை நோக்கிச் செல்லும்.",
    "gmRemindStreak": "உங்கள் {n}-நாள் வரிசையை உயிருடன் வைத்திருங்கள்: நள்ளிரவுக்கு முன் ஒரு பாடம் செய்யுங்கள்.",
    "gmReminderDays": "இந்த நாட்களில்",
    "gmReminderTime": "இந்த நேரத்திலிருந்து",
    "gmReminders": "நினைவூட்டல்கள்",
    "gmRemindersOn": "எனது தொடர் அல்லது அன்றாட இலக்கு ஆபத்தில் இருக்கும்போது இந்த தளத்தில் எனக்கு நினைவூட்டுங்கள்",
    "gmRule_assignment": "பணி நிறைவு",
    "gmRule_badge": "பேட்ஜ் சம்பாதித்தது",
    "gmRule_concept": "கருத்தியல் தேர்ச்சி",
    "gmRule_course": "படிப்பு நிறைவு",
    "gmRule_daily_goal": "தினசரி இலக்கு எட்டப்பட்டது",
    "gmRule_forum_post": "கலந்துரையாடல் இடுகை",
    "gmRule_lesson": "பாடம் முடிந்தது",
    "gmRule_problem": "சிக்கல் தீர்ந்தது",
    "gmRule_quest": "கேள்வி முடிந்தது",
    "gmRule_quiz_pass": "வினாடி வினா முடிந்தது",
    "gmRule_quiz_perfect": "சரியான மதிப்பெண் போனஸ்",
    "gmRule_streak": "அடுக்கு மைல்கல்",
    "gmRule_video": "வீடியோ முடிந்தது",
    "gmRule_weekly_goal": "வாராந்திர இலக்கு நிறைவேற்றப்பட்டது",
    "gmSaveAvatar": "அவதாரத்தை சேமிக்கவும்",
    "gmSaveSettings": "அமைப்புகளைச் சேமிக்கவும்",
    "gmSeeAll": "அனைத்தையும் பாருங்கள்",
    "gmShow": "காட்டு",
    "gmShowMe": "தலைசிறந்த பலகைகளில் எனக்குக் காட்டுங்கள்",
    "gmSlot_badge": "முத்திரை",
    "gmSlot_eyes": "கண் ஆடைகள்",
    "gmSlot_frame": "சட்டகம்",
    "gmSlot_head": "தலைக்கவசம்",
    "gmStat_active_days": "செயல்பாட்டு நாட்கள்",
    "gmStat_concepts": "கருத்தாக்கங்கள் தேர்ச்சி பெற்றன",
    "gmStat_courses": "படிப்புகள் நிறைவடைந்தன",
    "gmStat_forum_posts": "கலந்துரையாடல் பதிவுகள்",
    "gmStat_lessons": "பாடங்கள்",
    "gmStat_perfect": "சரியான மதிப்பெண்கள்",
    "gmStat_problems": "பிரச்சினைகள் தீர்க்கப்பட்டன",
    "gmStat_quizzes": "வினாடி வினாக்கள் நிறைவேற்றப்பட்டன",
    "gmStat_videos": "வீடியோக்கள்",
    "gmStats": "உங்கள் புள்ளிவிவரங்கள்",
    "gmStreak": "ஸ்ட்ரைக்",
    "gmTab_achievements": "சாதனைகள்",
    "gmTab_avatar": "அவதாரம்",
    "gmTab_leaderboard": "தலைவர் பலகை",
    "gmTab_overview": "கண்ணோட்டம்",
    "gmTab_quests": "கேள்விகள்",
    "gmTab_settings": "அமைப்புகள்",
    "gmThisWeek": "இந்த வாரம்",
    "gmTimeZone": "நாட்கள் உங்கள் நேர மண்டலத்தில் கணக்கிடப்படுகின்றன: {tz}.",
    "gmTitle": "எனது முன்னேற்றம்",
    "gmToNext": "{xp} XP நிலை {level}",
    "gmToday": "இன்று",
    "gmTokens": "{n} வரி உறைகிறது",
    "gmUnlockBadge": "ஒரு பேட்ஜைப் பெறுங்கள்",
    "gmUnlockLevel": "நிலை {level}",
    "gmView": "காட்சி",
    "gmWeekDown": "{xp} XP கடந்த வாரத்தை விட குறைவாக உள்ளது.",
    "gmWeekFirst": "உங்கள் கண்காணிப்பின் முதல் வாரம்.",
    "gmWeekUp": "{xp} எக்ஸ்பி கடந்த வாரத்தை விட அதிகமாக உள்ளது.",
    "gmWeeklyTarget": "இந்த வாரம் {target} கற்றல் நாட்களில் {done}",
    "gmWeeklyTargetSetting": "வாரத்தில் கற்றல் நாட்கள்",
    "gmXpHistory": "எக்ஸ்பி வரலாறு",
    "gmYouHidden": "நீங்கள் (இதை நீங்கள் மட்டுமே பார்க்கிறீர்கள்)",
    "gmYourRank": "நீங்கள் {xp} XP உடன் #{rank}.",
    "heroPointPace": "உங்கள் சொந்த வேகத்தில் கற்றுக்கொள்ளுங்கள்",
    "home": "வீடு",
    "homeCoursesError": "படிப்புகளை ஏற்ற முடியவில்லை. தயவுசெய்து பின்னர் மீண்டும் முயற்சிக்கவும்.",
    "invalidEmail": "தயவுசெய்து ஒரு செல்லுபடியாகும் மின்னஞ்சல் முகவரியை உள்ளிடவும்.",
    "language": "மொழி",
    "lastUpdated": "கடைசியாக புதுப்பிக்கப்பட்டது: {date}",
    "legalTranslatedNote": "இந்தப் பக்கம் தானாகவே மொழிபெயர்க்கப்பட்டது. ஏதேனும் வேறுபட்டால், ஆங்கிலப் பதிப்பு பொருந்தும்.",
    "loading": "ஏற்றப்படுகிறது...",
    "lpBy": "மூலம் {date}",
    "lpCancel": "ரத்து செய்யுங்கள்",
    "lpCreate": "எனது பாதையை திட்டமிடுங்கள்",
    "lpEdit": "இலக்கை மாற்றுங்கள்",
    "lpFailed": "உங்களது பாதையை இப்போது எங்களால் திட்டமிட முடியவில்லை. தயவுசெய்து பின்னர் மீண்டும் முயற்சிக்கவும்.",
    "lpGoalLabel": "நீங்கள் எதை அடைய விரும்புகிறீர்கள்?",
    "lpGoalPlaceholder": "எடுத்துக்காட்டாக: ஒரு வருடத்திற்குள் தரவு ஆய்வாளராக வேலை பெறுங்கள், அல்லது எனது கைவினைப் பொருட்களை ஆன்லைனில் விற்கத் தொடங்குங்கள்.",
    "lpGoalShort": "உங்கள் இலக்கை ஒன்று அல்லது இரண்டு வாக்கியங்களில் விவரிக்கவும்.",
    "lpHours": "வாரத்திற்கு மணிநேரங்கள்",
    "lpHoursShort": "{hours} வாரத்திற்கு மணிநேரங்கள்",
    "lpLevel": "உங்கள் நிலை",
    "lpLevelUnsure": "உறுதியாக தெரியவில்லை",
    "lpLimit": "இன்று நீங்கள் பல பாதைகளைத் திட்டமிட்டுள்ளீர்கள். நாளை மீண்டும் முயற்சிக்கவும்.",
    "lpPassed": "நிறைவு செய்யப்பட்டது",
    "lpPlan": "எனது கற்றல் பாதையைத் திட்டமிடுங்கள்",
    "lpPrivacy": "உங்கள் இலக்கு மற்றும் பாடத்திட்ட வரலாறு உங்கள் பாதையைத் திட்டமிட மட்டுமே பயன்படுத்தப்படுகின்றன.",
    "lpProgress": "பதிவுசெய்யப்பட்டது · {percent}% s o தூரம்",
    "lpSignIn": "உங்கள் இலக்கு, உங்கள் நிலை மற்றும் நீங்கள் ஏற்கனவே எடுத்துள்ள படிப்புகளின் அடிப்படையில் ஒரு கற்றல் பாதையைத் திட்டமிட உள்நுழைக.",
    "lpSummary": "உங்கள் குறிக்கோள் மற்றும் உங்களுக்கு இருக்கும் நேரத்தை எங்களிடம் கூறுங்கள். எந்தப் படிப்புகளை, எந்த வரிசையில் எடுக்க வேண்டும் என்பதை AI திட்டமிடுகிறது.",
    "lpTarget": "இலக்கு தேதி (விருப்பப்படி)",
    "lpTitle": "எனது கற்றல் பாதை",
    "lpTopics": "நீங்கள் ஆர்வமாக உள்ள தலைப்புகள் (விருப்பப்படி)",
    "lpUpdate": "எனது பாதையை புதுப்பிக்கவும்",
    "lpWorking": "உங்கள் பாதையை திட்டமிடுங்கள்...",
    "lpWorkingNote": "இதற்கு சில விநாடிகள் ஆகும்.",
    "lpYourGoal": "உங்கள் இலக்கு",
    "lpYourPath": "உங்கள் பாதை",
    "lvA_attended": "கலந்து கொண்டார்",
    "lvA_avg": "சராசரி நேரம்",
    "lvA_chats": "அரட்டைச் செய்திகள்",
    "lvA_hands": "கைகளை உயர்த்தினார்",
    "lvA_learner": "கற்றவர்",
    "lvA_minutes": "நிமிடங்கள்",
    "lvA_pending": "வகுப்பு இயங்கும் போது கூட்டத்தில் யார் இருந்தார்கள் என்பதை பெரிதாக்கு அறிக்கைகள்; அதுவரை மட்டுமே கிளிக் செய்க.",
    "lvA_polls": "தேர்தல் பதில்கள்",
    "lvA_status": "நிலை",
    "lvA_talk": "பேச்சு (நிமிடம்)",
    "lvAbsent": "இல்லாதது",
    "lvAddCalendar": "நாட்காட்டியில் சேர்க்கவும்",
    "lvAddRecording": "பதிவைச் சேர்க்கவும்",
    "lvAnnounce": "புதிய வகுப்பைப் பற்றி பதிவு செய்த மாணவர்களுக்கு மின்னஞ்சல் அனுப்பவும்",
    "lvAttendance": "வருகை",
    "lvAttendedN": "{total} இன் {n} கலந்து கொண்டது",
    "lvCancelClass": "வகுப்பை ரத்து செய்யு",
    "lvCancelConfirm": "இந்த வகுப்பை ரத்து செய்யுங்கள்? கற்பவர்கள் இனி அதைப் பார்க்க மாட்டார்கள்.",
    "lvCancelEdit": "ரத்து செய்யுங்கள்",
    "lvCancelSeries": "இந்த வாராந்திர தொடரின் பிற்கால வகுப்புகளையும் ரத்து செய்யுங்கள்.",
    "lvCaptionLang": "தலைப்புகளின் மொழி",
    "lvCaptionsDone": "தலைப்புகள் சேர்க்கப்பட்டன.",
    "lvCaptionsHelp": "ஒரு வி. டி. டி அல்லது எஸ். ஆர். டி கோப்பு (எடுத்துக்காட்டாக யூடியூப் அல்லது டிரான்ஸ்கிரிப்ஷன் கருவியிலிருந்து ஏற்றுமதி செய்யப்படுகிறது). இது டிரான்ஸ்கிரிப்டாகவும் மாறுகிறது.",
    "lvCaptionsIn": "தலைப்புகள்: {langs}",
    "lvCaptionsLabel": "தலைப்புகள்:",
    "lvCaptionsTranslating": "தலைப்புகள் சேர்க்கப்பட்டன; {n} மொழிகளில் மொழிபெயர்ப்பு (சில நிமிடங்கள்).",
    "lvCheckCloud": "பெரிதாக்கு மேகக்கணி பதிவைப் பெறுங்கள்",
    "lvCoHostsHelp": "இணை புரவலர்களைத் தேர்ந்தெடுக்க ஸ்டுடியோவில் (அமைப்புகள் → பாடநெறி குழு) பாடநெறி ஊழியர்களைச் சேர்க்கவும்.",
    "lvCopied": "இணைப்பு நகலெடுக்கப்பட்டது",
    "lvCsv": "CSV ஐப் பதிவிறக்கவும்",
    "lvDashTitle": "வரவிருக்கும் நேரடி வகுப்புகள்",
    "lvDelete": "நீக்கு",
    "lvDeleteRecConfirm": "இந்தப் பதிவை நிரந்தரமாக நீக்க முடியுமா?",
    "lvDetails": "விவரங்கள்",
    "lvEdit": "திருத்தவும்",
    "lvEditClass": "வகுப்பைத் திருத்து",
    "lvEmailReminders": "நினைவூட்டல்களை எனக்கு மின்னஞ்சல் அனுப்புங்கள்",
    "lvEnd": "அனைவருக்காகவும் முடிவு",
    "lvEndConfirm": "இப்போது அனைவருக்கும் வகுப்பை முடித்து விடுங்கள்?",
    "lvEnrolFirst": "அதன் நேரடி வகுப்புகளைப் பார்க்க இந்த பாடத்திட்டத்தில் சேருங்கள்.",
    "lvErr_captions": "அந்த கோப்பு செல்லுபடியாகும் வி. டி. டி அல்லது எஸ். ஆர். டி தலைப்பு கோப்பு அல்ல.",
    "lvErr_date": "செல்லுபடியாகும் தேதி மற்றும் நேரத்தைத் தேர்ந்தெடுக்கவும்.",
    "lvErr_duration": "10 முதல் 300 நிமிடங்களுக்கு இடையேயான கால அளவைத் தேர்ந்தெடுக்கவும்.",
    "lvErr_file": "ஒரு தலைப்பு கோப்பைத் தேர்ந்தெடுக்கவும் (வி. டி. டி அல்லது எஸ். ஆர். டி, 5 எம்பி வரை).",
    "lvErr_generic": "ஏதோ தவறு நடந்துவிட்டது. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
    "lvErr_host": "புரவலன் பாடத்திட்ட அணியில் இருக்க வேண்டும்.",
    "lvErr_not-configured": "ஜூம் இன்னும் இணைக்கப்படவில்லை.",
    "lvErr_number": "ஒரு எண்ணை உள்ளிடவும்.",
    "lvErr_plan": "இதற்கு கட்டண ஜூம் திட்டம் தேவைப்படுகிறது.",
    "lvErr_timezone": "ஒரு நேர மண்டலத்தைத் தேர்ந்தெடுக்கவும்.",
    "lvErr_title": "ஒரு தலைப்பை உள்ளிடவும் (3 முதல் 200 எழுத்துக்கள்).",
    "lvErr_unit": "இந்தப் பாடத்திட்டத்தின் ஒரு பாடத்தைத் தேர்ந்தெடுக்கவும்.",
    "lvErr_unreachable": "பெரிதாக்குதலை அணுக முடியவில்லை.",
    "lvErr_url": "ஒரு முழு இணைப்பை உள்ளிடவும்ஃ// /",
    "lvF_co_hosts": "இணை புரவலர்கள்",
    "lvF_date": "தேதி",
    "lvF_description": "விளக்கம் (கற்பவர்களுக்கு காட்டப்பட்டுள்ளது)",
    "lvF_duration": "காலம்",
    "lvF_host": "புரவலன்",
    "lvF_repeat": "மீண்டும் செய்யவும்",
    "lvF_time": "தொடங்கும் நேரம்",
    "lvF_timezone": "நேர மண்டலம்",
    "lvF_title": "தலைப்பு",
    "lvF_unit": "பாடம்",
    "lvF_welcome": "அறைக்குள் வரவேற்கத்தக்க செய்தி",
    "lvForLesson": "பாடத்திற்கு: {lesson}",
    "lvForbidden": "பாடநெறி குழு மட்டுமே அதன் நேரடி வகுப்புகளை நிர்வகிக்க முடியும்.",
    "lvFreeLimit": "இலவச ஜூம் திட்டம் {n} நிமிடங்களுக்குப் பிறகு கூட்டங்களை முடிக்கிறது; கற்பவர்கள் அதே இணைப்புடன் மீண்டும் சேரலாம்.",
    "lvFreeNote": "இலவச ஜூம் திட்டம்: கூட்டங்கள் 40 நிமிடங்கள் வரை நீடிக்கும், பதிவுகள் புரவலனின் கணினியில் சேமிக்கப்படுகின்றன, மேலும் கருத்துக்கணிப்புகளுக்கு கட்டண திட்டம் தேவைப்படுகிறது (அரட்டை அல்லது எதிர்வினைகளைப் பயன்படுத்தவும்). பிரேக்அவுட் அறைகள், திரை பகிர்வு, வெள்ளைப்பலகை மற்றும் காத்திருப்பு அறை வேலை.",
    "lvGoogleCalendar": "கூகுள் காலண்டர்",
    "lvHideTranscript": "டிரான்ஸ்கிரிப்டை மறைக்கவும்",
    "lvHost": "புரவலன்: {name}",
    "lvInDays": "{n} நாட்களில்",
    "lvInHours": "{n} h இல்",
    "lvInMinutes": "{n} நிமிடத்தில்",
    "lvIntro": "ஜூம் மூலம் நேரடி வகுப்புகளைத் திட்டமிடுங்கள், அவற்றை இயக்கவும், வருகை மற்றும் பதிவுகளைப் பின்பற்றவும்.",
    "lvJoin": "வகுப்பில் சேருங்கள்",
    "lvJoinError_cancelled": "இந்த வகுப்பு ரத்து செய்யப்பட்டது.",
    "lvJoinError_ended": "இந்த வகுப்பு முடிந்துவிட்டது.",
    "lvJoinError_not-configured": "நேரடி வகுப்புகள் இன்னும் கிடைக்கவில்லை.",
    "lvJoinError_not-enrolled": "பாடத்திட்டத்தில் பதிவு செய்தவர்கள் மட்டுமே சேர முடியும்.",
    "lvJoinError_not-started": "பயிற்றுவிப்பாளர் வகுப்பைத் திறக்கும் வரை காத்திருப்பது... இந்தப் பக்கம் தானாகவே உங்களுடன் சேரும்.",
    "lvJoinError_too-early": "வகுப்பு இன்னும் திறக்கப்படவில்லை.",
    "lvJoinError_unavailable": "வகுப்பைத் திறக்க முடியவில்லை. தயவுசெய்து ஒரு கணத்தில் மீண்டும் முயற்சிக்கவும்.",
    "lvJoinHost": "புரவலனாக சேருங்கள்",
    "lvJoinedBriefly": "சுருக்கமாக சேர்ந்தார்",
    "lvLessonClass": "இந்தப் பாடத்திற்கான நேரடி வகுப்பு: {title}",
    "lvLoadError": "நேரடி வகுப்புகளை ஏற்ற முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
    "lvMe": "நான்",
    "lvMinutes": "{n} நிமிடம்",
    "lvModerator": "புரவலன்",
    "lvMore": "{n} உங்கள் படிப்புகளில் மேலும்.",
    "lvNoCaptions": "இன்னும் தலைப்புகள் இல்லை.",
    "lvNoCourses": "நீங்கள் இன்னும் எந்த பாடத்தையும் கற்பிக்கவில்லை.",
    "lvNoRecordingsYet": "இன்னும் பதிவு செய்யவில்லை. உங்கள் பதிவுக்கு இணைப்பைச் சேர்க்கவும் (யூடியூப் பட்டியலிடப்படவில்லை, கூகிள் டிரைவ்...) கீழே.",
    "lvNoUpcoming": "தற்போது நேரடி வகுப்புகள் எதுவும் திட்டமிடப்படவில்லை.",
    "lvNonePast": "வகுப்புகள் இன்னும் நடத்தப்படவில்லை.",
    "lvNoneScheduled": "வகுப்புகள் எதுவும் திட்டமிடப்படவில்லை. தொடங்குவதற்கு ஒன்றைத் திட்டமிடவும்.",
    "lvNotConfigured": "நேரடி வகுப்புகள் நடத்தப்பட்டு வருகின்றன. விரைவில் சேர முடியும்.",
    "lvO_breakout_rooms": "குழு வேலைக்கான பிரேக்அவுட் அறைகள்",
    "lvO_mute_on_start": "கற்றவர்கள் சேரும்போது அவர்களை முடக்குங்கள்",
    "lvO_record": "வகுப்பைப் பதிவு செய்யுங்கள் (இலவச ஜூம் திட்டத்தில், உங்கள் கணினியில் பதிவு செய்து, பின்னர் இணைப்பைச் சேர்க்கவும்)",
    "lvO_waiting_room": "காத்திருப்பு அறை: ஒரு புரவலர் அவர்களை அனுமதிக்கும் வரை கற்பவர்கள் காத்திருக்கிறார்கள்",
    "lvO_webcams_only_for_moderators": "அவர்கள் சேரும்போது கற்பவர்களின் வீடியோவை அணைக்கவும்",
    "lvOnce": "ஒரு முறை மட்டுமே",
    "lvOpensAt": "நீங்கள் {time} இலிருந்து சேரலாம்",
    "lvPasscode": "கடவுச்சொல் {code}",
    "lvPast": "கடந்த வகுப்புகள்",
    "lvPhase_cancelled": "ரத்து செய்யப்பட்டது",
    "lvPhase_ended": "முடிந்தது",
    "lvPhase_live": "இப்போது வாழ்க",
    "lvPhase_open": "சேரத் திறக்கவும்",
    "lvPhase_upcoming": "வரவிருக்கும்",
    "lvPickCourse": "அதன் நேரடி வகுப்புகளை திட்டமிட ஒரு பாடத்திட்டத்தைத் தேர்ந்தெடுக்கவும்.",
    "lvPresent": "தற்போது",
    "lvPreview": "முன்னோட்டம்",
    "lvPublish": "கற்றவர்களுக்கு வெளியிடுங்கள்",
    "lvR_askAi": "உதவிக்குறிப்பு: நேரடி வகுப்புகளில் பங்கேற்பது பற்றி கற்றல் பகுப்பாய்வுகளைக் கேளுங்கள், எ. கா. \"நேரடி வகுப்புகளில் பாதிக்கும் குறைவானவர்கள் யார்?\"",
    "lvR_enrolled": "{n} பதிவு செய்யப்பட்ட கற்றவர்களின்",
    "lvR_held": "வகுப்புகள் நடைபெற்றன",
    "lvR_rate": "வருகை விகிதம்",
    "lvR_recs": "பதிவுகள்",
    "lvR_upcoming": "வரவிருக்கும்",
    "lvR_when": "எப்போது?",
    "lvRecFreeHelp": "உங்கள் கணினியிலிருந்து யூடியூப் (பட்டியலிடப்படாத) அல்லது கூகிள் டிரைவ் (இணைப்பைக் கொண்ட எவரும்) க்கு பதிவேற்றம் செய்து, இணைப்பை இங்கே ஒட்டவும், பின்னர் அதை வெளியிடவும்.",
    "lvRecMinutes": "நீளம் (நிமிடம்)",
    "lvRecPaidHelp": "ஜூம் மேகக்கணி பதிவுகள் வகுப்புக்குப் பிறகு சில நிமிடங்களில் தானாகவே இங்கே சேர்க்கப்படுகின்றன; நீங்கள் மற்ற இணைப்புகளையும் சேர்க்கலாம்.",
    "lvRecPasscode": "கடவுச்சொல்: {code}",
    "lvRecUrl": "பதிவு இணைப்பு",
    "lvRec_deleted": "நீக்கப்பட்டது",
    "lvRec_draft": "வெளியிடப்படவில்லை",
    "lvRec_processing": "செயலாக்கம்",
    "lvRec_published": "வெளியிடப்பட்டது",
    "lvRecordingOff": "இந்த வகுப்பிற்காக பதிவு செய்தல் அணைக்கப்பட்டது.",
    "lvRecordingSoon": "பயிற்றுவிப்பாளர் அதை வெளியிட்டவுடன் பதிவு இங்கே தோன்றும்.",
    "lvRecordingsN": "பதிவுகள் ({n})",
    "lvRemindersNote": "வகுப்புக்கு ஒரு நாள் மற்றும் 15 நிமிடங்களுக்கு முன்பு கற்பவர்கள் நினைவூட்டும் மின்னஞ்சல்களைப் பெறுகிறார்கள், மேலும் தொடங்குவதற்கு சில நிமிடங்களுக்கு முன்பு இருந்து {early} இல் சேரலாம். புரவலர்கள் எந்த நேரத்திலும் அறையைத் திறக்கலாம்.",
    "lvRoomOptions": "அறைகள் விருப்பங்கள்",
    "lvSave": "மாற்றங்களைச் சேமிக்கவும்",
    "lvSchedule": "அட்டவணை",
    "lvScheduleClass": "வகுப்பைத் திட்டமிடுங்கள்",
    "lvServerMissing": "ஜூம் இன்னும் இணைக்கப்படவில்லை: நீங்கள் இப்போது வகுப்புகளைத் திட்டமிடலாம்; ஜூம் கூட்டங்கள் உருவாக்கப்படுகின்றன மற்றும் ஜூம் பயன்பாட்டு விசைகள் சேர்க்கப்பட்டவுடன் வேலையைத் தொடங்குகின்றன மற்றும் சேருகின்றன.",
    "lvShowTranscript": "டிரான்ஸ்கிரிப்டைக் காட்டு",
    "lvStart": "வகுப்பைத் தொடங்குங்கள்",
    "lvStartingNow": "இப்போதிருந்து தொடங்குங்கள்",
    "lvSubscribe": "நாட்காட்டி இணைப்பை நகலெடுக்கவும்",
    "lvSubscribeHelp": "ஒவ்வொரு வகுப்பையும் தானாகவே பார்க்க இந்த இணைப்பை கூகிள் காலண்டர், அவுட்லுக் அல்லது உங்கள் தொலைபேசியில் சேர்க்கவும்.",
    "lvTab_past": "கடந்த காலம்",
    "lvTab_report": "அறிக்கை",
    "lvTab_upcoming": "வரவிருக்கும்",
    "lvTimesIn": "நேரங்கள் உங்கள் நேர மண்டலத்தில் காட்டப்படுகின்றன ({zone}).",
    "lvTitle": "நேரடி வகுப்புகள்",
    "lvTranslateTo": "மேலும் மொழிபெயர்க்கவும்",
    "lvUnpublish": "வெளியிட வேண்டாம்",
    "lvUpcoming": "வரவிருக்கும் வகுப்புகள்",
    "lvUploadCaptions": "தலைப்புகளைப் பதிவேற்றவும்",
    "lvWatch": "பதிவு செய்வதைப் பாருங்கள் ({n} நிமிடம்)",
    "lvWeekly": "வாராந்திர தொடர்",
    "lvWeeks": "ஒவ்வொரு வாரமும், {n} வகுப்புகள்",
    "lvWholeCourse": "முழு பாடமும் (குறிப்பிட்ட பாடம் இல்லை)",
    "lvYouAttended": "நீங்கள் கலந்து கொண்டீர்கள் ({n} நிமிடம்)",
    "lvYouMissed": "நீங்கள் இந்த வகுப்பை தவறவிட்டீர்கள்",
    "lvZoomError_auth": "ஜூம் பயன்பாட்டு விசைகளை மறுத்தது: சர்வர்-டு-சர்வர் ஓஅத் பயன்பாட்டைச் சரிபார்க்கவும்.",
    "lvZoomError_error": "ஜூம் கூட்டத்தை உருவாக்க முடியவில்லை: நீங்கள் வகுப்பைத் தொடங்கும் போது அது மீண்டும் முயற்சிக்கப்படும்.",
    "lvZoomError_not-configured": "ஜூம் இணைக்கப்படவில்லை: ஜூம் அமைக்கப்படும்போது கூட்டம் உருவாக்கப்படும்.",
    "lvZoomError_plan": "இதற்கு கட்டண ஜூம் திட்டம் தேவைப்படுகிறது.",
    "lvZoomError_unreachable": "பெரிதாக்குதலை அணுக முடியவில்லை: நீங்கள் வகுப்பைத் தொடங்கும் போது கூட்டம் உருவாக்கப்படும்.",
    "lvZoomMeeting": "கூட்டத்தை பெரிதாக்குங்கள் {id}",
    "messageLabel": "செய்தி",
    "myDashboard": "எனது டாஷ்போர்டு",
    "nameLabel": "முழுப் பெயர்",
    "newerPosts": "புதிய பதிவுகள்",
    "newsletterConfirmed": "நீங்கள் சந்தா பெற்றுள்ளீர்கள்",
    "newsletterConfirmedText": "உறுதி செய்ததற்கு நன்றி. எங்கள் அடுத்த செய்திமடல் உங்கள் இன்பாக்ஸை அடையும்.",
    "newsletterError": "இப்போதுதான் எங்களால் உங்களுக்கு சந்தா செலுத்த முடியவில்லை. தயவுசெய்து பின்னர் மீண்டும் முயற்சிக்கவும்.",
    "newsletterInvalid": "இந்த இணைப்பு வேலை செய்யவில்லை",
    "newsletterInvalidText": "இணைப்பு முழுமையடையாததாகவோ அல்லது காலாவதியானதாகவோ இருக்கலாம். தயவுசெய்து எந்தப் பக்கத்தின் கீழிருந்தும் மீண்டும் சந்தா செலுத்துங்கள்.",
    "newsletterText": "புதிய படிப்புகள், கற்றல் உதவிக்குறிப்புகள் மற்றும் ThervuMitra செய்திகள் உங்கள் இன்பாக்ஸில் உள்ளன.",
    "newsletterThanks": "கிட்டத்தட்ட முடிந்துவிட்டது! தயவுசெய்து உங்கள் இன்பாக்ஸை சரிபார்த்து உங்கள் சந்தாவை உறுதிப்படுத்தவும்.",
    "newsletterTitle": "செய்திமடல்",
    "newsletterUnsubscribed": "நீங்கள் சந்தா விலக்கிவிட்டீர்கள்",
    "newsletterUnsubscribedText": "இனி எங்கள் செய்திமடலை நீங்கள் பெற மாட்டீர்கள். எந்தப் பக்கத்தின் கீழிருந்தும் நீங்கள் எப்போது வேண்டுமானாலும் மீண்டும் சந்தா செலுத்தலாம்.",
    "noPosts": "இன்னும் பதிவுகள் எதுவும் இல்லை. தயவுசெய்து விரைவில் மீண்டும் சரிபார்க்கவும்.",
    "notFound": "பக்கம் காணப்படவில்லை",
    "notFoundText": "நீங்கள் தேடும் பக்கம் இல்லை அல்லது நகர்த்தப்பட்டுள்ளது.",
    "nudgeDismiss": "பதவி நீக்கம்",
    "nudgeOpenPath": "என் பாதை",
    "nudgeRevise": "இந்த அலகு {concepts} ஐ உருவாக்குகிறது, இது உங்களுக்கு கடினமாக உள்ளது. முதலில் திருத்தவும்:",
    "nudgeSkip": "இந்த அலகு எதை உள்ளடக்கியது என்பது உங்களுக்கு ஏற்கனவே தெரியும். அதைச் சரிசெய்யவும் அல்லது தொடரவும்.",
    "nudgeStruggling": "நீங்கள் {concepts} கடினமாகக் காண்கிறீர்கள். இங்கே உங்கள் நேரத்தை எடுத்துக் கொள்ளுங்கள், நீங்கள் சிக்கித் தவிப்பீர்களா என்று AI ஆசிரியரிடம் கேளுங்கள்.",
    "olderPosts": "பழைய பதிவுகள்",
    "onThisPage": "இந்தப் பக்கத்தில்",
    "pageOf": "{pages} இன் பக்கம் {page}",
    "pageOriginalNote": "நீங்கள் அசல் ஆங்கில பதிப்பைப் படிக்கிறீர்கள்.",
    "pageTranslatedNote": "இந்தப் பக்கம் தானாகவே மொழிபெயர்க்கப்பட்டது மற்றும் அதில் தவறுகள் இருக்கலாம்.",
    "pathAllDone": "இந்த பாடத்திட்டத்தில் நீங்கள் அனைத்தையும் உள்ளடக்கியுள்ளீர்கள்",
    "pathAllDoneText": "கீழேயுள்ள மதிப்புரைகளுடன் உங்கள் அறிவை புதுப்பித்த நிலையில் வைத்திருங்கள், அல்லது அடுத்து என்ன கற்றுக்கொள்வது என்று பாருங்கள்.",
    "pathAskTutor": "செயற்கை நுண்ணறிவு ஆசிரியரிடம் கேளுங்கள்",
    "pathBehind": "இந்த வேகத்தில் நீங்கள் பாடத்திட்டம் முடிவதற்கு முன்பு முடிக்காமல் போகலாம். ஒவ்வொரு வாரமும் இன்னும் கொஞ்சம் அதிகமாக பொருந்த முயற்சிக்கவும்.",
    "pathConcepts": "உங்கள் கருத்துக்கள்",
    "pathConceptsSummary": "இந்த பாடத்திட்டத்தில் நீங்கள் {mastered} இல் {total} கருத்துகளில் தேர்ச்சி பெற்றுள்ளீர்கள்.",
    "pathContinue": "அலகுக்குச் செல்லுங்கள்",
    "pathDiagNotTaken": "உங்களுக்கு ஏற்கனவே தெரிந்தவற்றின் {count}-கேள்வி சரிபார்ப்பு.",
    "pathDiagTaken": "கடைசி முடிவு: {total} இன் {score}.",
    "pathError": "ஏதோ தவறு நடந்துவிட்டது. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
    "pathIntro": "இந்த பாடத்திட்டத்திற்கான உங்கள் தனிப்பட்ட திட்டம்: இதுவரை நீங்கள் அளித்த பதில்களின் அடிப்படையில் அடுத்து என்ன படிக்க வேண்டும், எதைத் தவிர்க்கலாம், எதைத் திருத்த வேண்டும்.",
    "pathNextCourses": "அடுத்து என்ன கற்றுக்கொள்ள வேண்டும்?",
    "pathNextText": "இந்த அலகு பின்வருவனவற்றை உள்ளடக்கியது: {concepts}.",
    "pathNextUp": "அடுத்தது",
    "pathNotReady": "இந்த பாடத்திட்டத்திற்கு தனிப்பயனாக்கப்பட்ட பாதைகள் இன்னும் கிடைக்கவில்லை",
    "pathNotReadyNote": "பாடத்திட்டம் பகுப்பாய்வு செய்யப்பட்டவுடன், அடுத்து எதைப் படிக்க வேண்டும், எதைத் தவிர்க்கலாம், எதைத் திருத்த வேண்டும் என்பதை இந்தப் பக்கம் காண்பிக்கும்.",
    "pathPace": "உங்கள் வேகம்",
    "pathPreparing": "இந்தப் படிப்புக்கான உங்கள் பாதை தயார் செய்யப்படுகிறது",
    "pathRevise": "திருத்தம்",
    "pathReviseFirst": "முதலில் திருத்தவும்",
    "pathReviseFirstText": "நீங்கள் {concepts} ஐக் கடினமாகக் காண்கிறீர்கள். முதலில் அதைத் திருத்துவது \"{next}\" ஐ மிகவும் எளிதாக்கும்.",
    "pathReviseNote": "நீங்கள் கடினமாகக் கண்டுபிடிக்கும் கருத்துக்கள், மற்றும் நீங்கள் அவற்றை நினைவில் கொள்ள ஒரு விரைவான மதிப்பாய்வு செய்ய வேண்டியவை.",
    "pathRevisePrereq": "கட்டமைக்கிறது: {concepts}",
    "pathShowAll": "அனைத்து {count} ஐயும் காட்டு",
    "pathShowLess": "குறைவாகக் காட்டு",
    "pathSkip": "நீங்கள் தவிர்க்கலாம்",
    "pathSkipNote": "இந்த அலகுகள் என்ன கற்பிக்கின்றன என்பது உங்களுக்கு ஏற்கனவே தெரியும். அவற்றைத் தவிர்க்கவும் அல்லது தொடரவும்.",
    "pathSkippable": "உங்களுக்கு ஏற்கனவே தெரிந்த {count} யூனிட்டுகளை நீங்கள் தவிர்க்கலாம்.",
    "pathStart": "கற்றுக்கொள்ளத் தொடங்குங்கள்",
    "pathStartText": "ஒரு குறுகிய {count}-கேள்வி சரிபார்ப்பை எடுத்துக் கொள்ளுங்கள். நீங்கள் தவிர்க்கக்கூடிய அலகுகளை நாங்கள் பரிந்துரைப்போம், முதலில் வேலை செய்ய இடைவெளிகளை சுட்டிக்காட்டலாம்.",
    "pathStartTitle": "உங்கள் தொடக்க புள்ளியைக் கண்டறியவும்",
    "pathState_known": "தெரிந்திருக்கலாம்",
    "pathState_learning": "கற்றல்",
    "pathState_mastered": "தேர்ச்சி பெற்றவர்",
    "pathState_not_started": "தொடங்கவில்லை",
    "pathState_review_due": "மதிப்பாய்வு செய்ய வேண்டிய",
    "pathState_struggling": "திருத்தம் தேவை",
    "pathTitle": "என் பாதை",
    "pathUnitsDone": "அலகுகள் நிறைவடைந்தன",
    "pathWeeksLeft": "உங்கள் சமீபத்திய வேகத்தில் (வாரத்திற்கு சுமார் {perWeek} அலகுகள்), நீங்கள் சுமார் {weeks} வாரங்களில் முடிப்பீர்கள்.",
    "phoneLabel": "தொலைபேசி எண் (விருப்பப்படி)",
    "popularSubtitle": "நமது பங்குதாரர் நிறுவனங்களிலிருந்து ஒரு பாடத்திட்டத்துடன் தொடங்குங்கள்.",
    "popularTitle": "மிகவும் பிரபலமான படிப்புகள்",
    "privacy": "தனியுரிமைக் கொள்கை",
    "readInEnglish": "ஆங்கிலத்தில் படியுங்கள்",
    "readMore": "மேலும் வாசிக்க",
    "readTranslated": "என் மொழியில் படியுங்கள்",
    "required": "இந்த புலம் தேவைப்படுகிறது.",
    "reviewAverageLabel": "5 இல் மதிப்பிடப்பட்ட {stars}",
    "reviewBeFirst": "இதுவரை எந்த விமர்சனமும் இல்லை. இந்தப் பாடத்திட்டத்தை எடுக்கும் மாணவர்கள்தான் முதலில் அதை மதிப்பாய்வு செய்யலாம்.",
    "reviewBeFirstShort": "இதுவரை விமர்சனங்கள் எதுவும் இல்லை",
    "reviewCancel": "ரத்து செய்யுங்கள்",
    "reviewCommentLabel": "உங்கள் மதிப்பாய்வு (விருப்பப்படி)",
    "reviewCommentPlaceholder": "உங்களுக்கு என்ன பிடித்திருந்தது? இதைவிடச் சிறப்பாக இருப்பது என்ன? உங்கள் மதிப்பாய்வு மற்ற மாணவர்களைத் தீர்மானிக்க உதவுகிறது.",
    "reviewCount": "{count} மதிப்புரைகள்",
    "reviewCountOne": "{count} மதிப்பாய்வு",
    "reviewDelete": "நீக்கு",
    "reviewDeleteConfirm": "இந்தப் பாடத்திட்டத்தைப் பற்றிய உங்கள் மதிப்பாய்வை நீக்குங்கள்?",
    "reviewEdit": "உங்கள் மதிப்பாய்வைத் திருத்து",
    "reviewEditTitle": "உங்கள் மதிப்பாய்வைத் திருத்து",
    "reviewEdited": "திருத்தப்பட்டது",
    "reviewEnrolPrompt": "மதிப்பீடு செய்து மதிப்பாய்வு செய்ய இந்த பாடத்திட்டத்தில் பதிவு செய்யுங்கள்.",
    "reviewError": "உங்கள் மதிப்பாய்வை சேமிக்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
    "reviewNeedRating": "தயவுசெய்து ஒரு நட்சத்திர மதிப்பீட்டைத் தேர்ந்தெடுக்கவும்.",
    "reviewNone": "இதுவரை விமர்சனங்கள் எதுவும் இல்லை",
    "reviewPublicNote": "உங்கள் முதல் பெயர் மற்றும் முதலாம் உங்கள் மதிப்பாய்வுடன் காட்டப்படும்.",
    "reviewShowMore": "மேலும் விமர்சனங்களைக் காட்டு",
    "reviewSignIn": "அதை மறுபரிசீலனை செய்ய உள்நுழைக",
    "reviewSignInPrompt": "நீங்கள் இந்த பாடத்திட்டத்தை எடுத்திருக்கிறீர்களா?",
    "reviewStar1": "ஏழ்மை",
    "reviewStar2": "நியாயமான",
    "reviewStar3": "நல்லாருக்கு",
    "reviewStar4": "மிகவும் நன்றாக உள்ளது",
    "reviewStar5": "சிறந்தது",
    "reviewStarsLabel": "{stars} 5 நட்சத்திரங்களில்",
    "reviewSubmit": "பின்னூட்ட விமர்சனம்",
    "reviewUpdate": "மதிப்பாய்வை புதுப்பிக்கவும்",
    "reviewWriteTitle": "இந்த பாடத்திட்டத்தை மதிப்பிடுங்கள்",
    "reviewYourRating": "உங்கள் மதிப்பீடு",
    "reviewYours": "உங்கள் விமர்சனம்",
    "reviewsTitle": "கற்றவர் விமர்சனங்கள்",
    "search": "தேடல்",
    "searchButton": "படிப்புகளைத் தேடுங்கள்",
    "searchPlaceholder": "நீங்கள் என்ன கற்றுக்கொள்ள விரும்புகிறீர்கள்?",
    "sendMessage": "செய்தி அனுப்பவும்",
    "sending": "அனுப்புகிறது...",
    "shAccessReady": "நீங்கள் பதிவு செய்து கொண்டீர்கள், உடனடியாக கற்றுக்கொள்ளத் தொடங்கலாம்.",
    "shAddToCart": "வண்டியில் சேர்க்கவும்",
    "shAdmAll": "அனைத்தும்",
    "shAdmAlways": "எப்போதும்",
    "shAdmCancel": "ரத்து செய்யுங்கள்",
    "shAdmCatalogFacts": "{courses} கட்டண படிப்புகள் · {refunded} பணத்தைத் திரும்பப் பெறுதல்",
    "shAdmCourses": "படிப்புகள்",
    "shAdmDeleteConfirm": "இதை நீக்குங்கள்? ஆர்டர் வரலாற்றை வைத்திருக்க, பயன்படுத்தப்பட்ட கூப்பன்கள் அணைக்கப்படுகின்றன.",
    "shAdmDenied": "மேடையில் பணிபுரியும் ஊழியர்கள் மட்டுமே வர்த்தகத்தை நிர்வகிக்க முடியும்.",
    "shAdmE_before-start": "முடிவு என்பது தொடக்கத்திற்குப் பிறகு இருக்க வேண்டும்.",
    "shAdmE_choice": "ஒரு விருப்பத்தைத் தேர்ந்தெடுக்கவும்.",
    "shAdmE_code": "3 முதல் 32 எழுத்துக்கள், இலக்கங்கள்,-அல்லது.",
    "shAdmE_date": "செல்லுபடியாகும் தேதியை உள்ளிடவும்.",
    "shAdmE_number": "ஒரு எண்ணை உள்ளிடவும்.",
    "shAdmE_percent": "ஒரு சதவீதம் 100 க்கு மேல் இருக்கக்கூடாது.",
    "shAdmE_required": "தேவைப்பட்டது.",
    "shAdmE_taken": "அந்த குறியீடு ஏற்கனவே பயன்படுத்தப்பட்டுள்ளது.",
    "shAdmEditBtn": "திருத்தவும்",
    "shAdmEdit_coupons": "கூப்பனைத் திருத்து",
    "shAdmEdit_offers": "சலுகையைத் திருத்து",
    "shAdmErr_invalid": "செல்லுபடியாகும் விலையை உள்ளிடவும்.",
    "shAdmErr_list-below-price": "MRP விலைக்குக் குறைவாக இருக்க முடியாது.",
    "shAdmF_active": "செயலில் உள்ளது",
    "shAdmF_badge": "பேட்ஜ்",
    "shAdmF_categories": "பிரிவுகள்",
    "shAdmF_code": "குறியீடு",
    "shAdmF_description": "விளக்கம்",
    "shAdmF_discount_type": "தள்ளுபடி வகை",
    "shAdmF_ends": "முடிவடைகிறது",
    "shAdmF_kind": "வகை",
    "shAdmF_max_discount": "அதிகபட்ச தள்ளுபடி (₹)",
    "shAdmF_min_items": "குறைந்தபட்ச உருப்படிகள்",
    "shAdmF_min_order": "குறைந்தபட்ச ஆர்டர் (₹)",
    "shAdmF_per_user_limit": "ஒரு கற்பவருக்கு பயன்படுத்தப்படும்",
    "shAdmF_products": "படிப்புகள்/திட்டங்கள்",
    "shAdmF_starts": "தொடக்கம்",
    "shAdmF_title": "தலைப்பு",
    "shAdmF_usage_limit": "மொத்த பயன்பாடுகள்",
    "shAdmF_value": "தள்ளுபடி",
    "shAdmFixed": "நிலையான தொகை (₹)",
    "shAdmH_badge": "தீபாவளி விற்பனை போன்ற பாடநெறி அட்டைகளில் குறுகிய முத்திரை.",
    "shAdmH_categories": "காற்புள்ளியில் இருந்து பிரிக்கப்பட்ட அட்டவணை வகைகள், எ. கா. நிதி மற்றும் பணம். காலியாக இருப்பது என்றால் அனைத்தும் என்று பொருள்.",
    "shAdmH_code": "3 முதல் 32 எழுத்துக்கள், இலக்கங்கள்,-அல்லது.",
    "shAdmH_max_discount": "0 என்றால் தொப்பி இல்லை என்று பொருள்.",
    "shAdmH_min_items": "மூட்டை தள்ளுபடியில் கார்டில் உள்ள பொருட்கள் தேவை.",
    "shAdmH_min_order": "0 என்றால் எந்த வரிசையும் என்று பொருள்.",
    "shAdmH_per_user_limit": "0 என்றால் வரம்பற்றது என்று பொருள்.",
    "shAdmH_products": "காற்புள்ளியில் இருந்து பிரிக்கப்பட்ட பாடத்திட்டம் ஐடி அல்லது நிரல் ஸ்லக்குகள். காலியாக இருப்பது என்றால் அனைத்தும் என்று பொருள்.",
    "shAdmH_usage_limit": "0 என்றால் வரம்பற்றது என்று பொருள்.",
    "shAdmIntro": "படிப்புகள் மற்றும் திட்டங்களுக்கான விலைகள், சலுகைகள், கூப்பன்கள் மற்றும் ஆர்டர்கள். விலைகளில் GST அடங்கும்.",
    "shAdmIntro_coupons": "குறியீடுகள் கற்றவர்கள் செக்அவுட்டில் நுழைகிறார்கள்.",
    "shAdmIntro_offers": "விற்பனை தானாகவே விலைகளைக் குறைக்கிறது; தள்ளுபடி வண்டிகளை போதுமான பொருட்களுடன் இணைக்கிறது.",
    "shAdmKind": "வகை",
    "shAdmKind_bundle": "தொகுப்பு",
    "shAdmKind_sale": "விற்பனை",
    "shAdmLearner": "கற்றவர்",
    "shAdmLive": "மாணவர்களைப் பாருங்கள்",
    "shAdmMinItems": "{n} + உருப்படிகள்",
    "shAdmMinOrder": "குறைந்தபட்சம். {amount}",
    "shAdmMrp": "MRP (₹)",
    "shAdmNew_coupons": "புதிய கூப்பன்",
    "shAdmNew_offers": "புதிய சலுகை",
    "shAdmNoGateway": "Razorpay விசைகள் கட்டமைக்கப்படவில்லை, எனவே கற்பவர்கள் இன்னும் பணம் செலுத்த முடியாது (இலவச மற்றும் 100% கூப்பன் ஆர்டர்கள் இன்னும் வேலை செய்கின்றன).",
    "shAdmNone": "இங்கு இன்னும் எதுவும் இல்லை.",
    "shAdmOnSale": "விற்பனைக்கு",
    "shAdmOrder": "ஆர்டர்",
    "shAdmOrderSearch": "ஆர்டர் எண், பயனர்பெயர் அல்லது மின்னஞ்சல்",
    "shAdmOrdersN": "{n} ஆர்டர்கள்",
    "shAdmPercent": "சதவீதம் (%)",
    "shAdmPrice": "விலை (₹)",
    "shAdmPricesNote": "விலை 0 ஒரு பொருளை இலவசமாக்குகிறது. MRP விருப்பமானது (காட்டப்பட்டுள்ளது). கட்டண படிப்புகளை வாங்குவதன் மூலம் மட்டுமே சேர முடியும்.",
    "shAdmRefund": "பணத்தைத் திருப்பிச் செலுத்துதல்",
    "shAdmRefundPrompt": "{number} ({amount}) முழுவதுமாக திருப்பிச் செலுத்தி, பாடத்திட்ட அணுகலை அகற்றுங்கள்? காரணம்:",
    "shAdmRefunded": "{number} திருப்பிச் செலுத்தப்பட்டது.",
    "shAdmSave": "சேமி",
    "shAdmSaved": "சேமித்த",
    "shAdmSearch": "தலைப்பு அல்லது ஐடி மூலம் தேடுங்கள்",
    "shAdmSearchBtn": "தேடல்",
    "shAdmStatus": "நிலை",
    "shAdmTab_coupons": "கூப்பன்கள்",
    "shAdmTab_offers": "சலுகைகள்",
    "shAdmTab_orders": "ஆர்டர்கள்",
    "shAdmTab_overview": "கண்ணோட்டம்",
    "shAdmTab_prices": "விலைகள்",
    "shAdmTitle": "வர்த்தகம்",
    "shAdmUsed": "பயன்படுத்தப்பட்டது",
    "shAdmWhen": "செல்லுபடியாகும்",
    "shAdm_all": "எல்லா நேரமும்",
    "shAdm_month": "கடந்த 30 நாட்கள்",
    "shAdm_today": "இன்று",
    "shAdm_week": "கடந்த 7 நாட்கள்",
    "shAmount": "தொகை",
    "shApply": "விண்ணப்பிக்கவும்",
    "shBackToCart": "வண்டிக்குத் திரும்பு",
    "shBillAddress": "கட்டண முகவரி",
    "shBillGstin": "GSTIN",
    "shBillName": "விலைப்பட்டியலில் பெயர்",
    "shBillState": "மாநிலம்",
    "shBilledTo": "அதற்குக் கட்டப்பட்டது",
    "shBilling": "கட்டண விவரங்கள்",
    "shBrowse": "படிப்புகளை உலாவவும்",
    "shBundleHint": "பல படிப்புகளை ஒன்றாக வாங்குவது? தொகுப்பு சலுகைகள் தானாகவே பயன்படுத்தப்படுகின்றன.",
    "shBuyNow": "இப்பொழுதே வாங்குங்கள்",
    "shCart": "வண்டிப் பெட்டி",
    "shCartCount": "கார்டு, {n} உருப்படிகள்",
    "shCartEmpty": "உங்கள் வண்டி காலியாக உள்ளது.",
    "shCgst": "CGST ({rate}%)",
    "shCheckout": "செக் அவுட்",
    "shChooseState": "உங்கள் மாநிலத்தைத் தேர்ந்தெடுக்கவும்",
    "shConfirming": "உங்கள் கட்டணத்தை உறுதிப்படுத்துகிறது...",
    "shCouponApplied": "கூப்பன் {code} பயன்படுத்தப்பட்டது",
    "shCouponLine": "கூப்பன் {code}",
    "shCouponPlaceholder": "கூப்பன் குறியீடு",
    "shCouponUsed": "பயன்படுத்தப்பட்ட கூப்பன்: {code}",
    "shCoupon_already-used": "நீங்கள் ஏற்கனவே இந்த கூப்பனை பயன்படுத்தியுள்ளீர்கள்.",
    "shCoupon_invalid": "அந்த கூப்பன் குறியீடு செல்லுபடியாகாது.",
    "shCoupon_min-order": "உங்கள் ஆர்டர் இந்த கூப்பனின் குறைந்தபட்சத்திற்குக் கீழே உள்ளது.",
    "shCoupon_not-applicable": "இந்த கூப்பன் உங்கள் கார்ட்டில் உள்ள பொருட்களுக்கு பொருந்தாது.",
    "shCoupon_used-up": "இந்த கூப்பன் முழுமையாக பயன்படுத்தப்பட்டுள்ளது.",
    "shCourse": "பாடத்திட்டம்",
    "shDiscount": "தள்ளுபடி",
    "shEnrollFree": "இலவசமாக பதிவு செய்யுங்கள்",
    "shEnrolling": "பதிவு செய்யுங்கள்...",
    "shErrorGeneric": "ஏதோ தவறு நடந்துவிட்டது. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
    "shError_cart-full": "உங்கள் வண்டியில் நிரம்பி உள்ளது. முதலில் எதையாவது பாருங்கள் அல்லது அகற்றுங்கள்.",
    "shError_coupon-already-used": "நீங்கள் ஏற்கனவே இந்த கூப்பனை பயன்படுத்தியுள்ளீர்கள்.",
    "shError_coupon-invalid": "அந்த கூப்பன் குறியீடு செல்லுபடியாகாது.",
    "shError_coupon-min-order": "உங்கள் ஆர்டர் இந்த கூப்பனின் குறைந்தபட்சத்திற்குக் கீழே உள்ளது.",
    "shError_coupon-not-applicable": "இந்த கூப்பன் உங்கள் கார்ட்டில் உள்ள பொருட்களுக்கு பொருந்தாது.",
    "shError_coupon-used-up": "இந்த கூப்பன் முழுமையாக பயன்படுத்தப்பட்டுள்ளது.",
    "shError_gateway-error": "பணம் செலுத்தும் சேவை ஒரு பிழையைத் திருப்பிக் கொடுத்தது. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
    "shError_gateway-unreachable": "கட்டணச் சேவையை அணுக முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
    "shError_gateway_script": "கட்டணச் சாளரத்தை ஏற்ற முடியவில்லை. உங்கள் இணைப்பைச் சரிபார்த்து மீண்டும் முயற்சிக்கவும்.",
    "shError_gstin": "அந்த GSTIN சரியாகத் தெரியவில்லை.",
    "shError_item": "ஏதோ தவறு நடந்துவிட்டது. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
    "shError_not-for-sale": "இது விற்பனைக்கு இல்லை.",
    "shError_not-paid": "கட்டண ஆர்டர்களை மட்டுமே திருப்பிச் செலுத்த முடியும்.",
    "shError_nothing-to-buy": "உங்கள் வண்டியில் பணம் செலுத்த எதுவும் இல்லை.",
    "shError_owned": "இது ஏற்கனவே உங்களுக்குச் சொந்தமானது.",
    "shError_payment-required": "இந்த திட்டத்திற்கு பணம் செலுத்தப்படுகிறது: பதிவு செய்ய அதை வாங்கவும்.",
    "shError_payments-not-configured": "ஆன்லைன் கட்டணங்கள் இன்னும் கிடைக்கவில்லை. தயவுசெய்து பின்னர் மீண்டும் முயற்சிக்கவும்.",
    "shFree": "இலவசமாக",
    "shGoDashboard": "எனது படிப்புகளுக்குச் செல்லுங்கள்",
    "shGoToCart": "வண்டிக்குச் செல்லுங்கள்",
    "shGstIncluded": "விலைகளில் 18% GST அடங்கும். பாடத்திட்டத்திற்கான வாழ்நாள் அணுகல்.",
    "shGstOf": "{amount} இன் GST ஐ உள்ளடக்கியது",
    "shGstinHelp": "உள்ளீட்டு வரிக் கடனுடன் ஒரு வணிக விலைப்பட்டியலுக்காக.",
    "shHaveCoupon": "கூப்பன் வைத்திருக்கிறீர்களா?",
    "shIgst": "IGST ({rate}%)",
    "shInvoiceFoot": "ஆன்லைன் கல்வி சேவைகள். இது கணினியால் உருவாக்கப்பட்ட விலைப்பட்டியல் மற்றும் கையொப்பம் தேவையில்லை.",
    "shInvoiceNo": "விலைப்பட்டியல் எண். {number}",
    "shInvoiceTo": "வரி விலைப்பட்டியல் எனது ஆர்டர்களின் ({email}) கீழ் கிடைக்கும்.",
    "shItem": "பொருள்",
    "shMoveToCart": "வண்டிக்கு நகர்த்தவும்",
    "shMyOrders": "எனது ஆணைகள்",
    "shNoOrders": "இன்னும் ஆர்டர் செய்யவில்லை.",
    "shOff": "{percent}% ஆஃப்",
    "shOfferEnds": "{title} முடிவடைகிறது {date}",
    "shOptional": "(விருப்பப்படி)",
    "shOrderNo": "ஆர்டர் {number}",
    "shOrderSummary": "ஆர்டர் சுருக்கம்",
    "shOrderTitle": "ஆர்டர் {number}",
    "shOwned": "வாங்கப்பட்டது",
    "shPaid": "செலுத்தப்பட்டது",
    "shPay": "{amount} செலுத்தவும்",
    "shPaymentCancelled": "பணம் செலுத்துவது ரத்து செய்யப்பட்டது. உங்களிடம் கட்டணம் வசூலிக்கப்படவில்லை.",
    "shPaymentFailed": "பணம் செலுத்துவதில் தோல்வியுற்றது. {reason}",
    "shPaymentRef": "பணம் செலுத்துதல் குறிப்பு. {id}",
    "shPlaceFree": "ஆர்டர் செய்யுங்கள்",
    "shPlaceOfSupply": "வழங்கல் இடம்: {state} ({code})",
    "shPrice": "விலை",
    "shPrintInvoice": "விலைப்பட்டியலை அச்சிடவும் அல்லது சேமிக்கவும்",
    "shRemove": "அகற்றவும்",
    "shSaveForLater": "பின்னர் சேமி",
    "shSecure": "Razorpay: UPI, அட்டைகள், நிகர வங்கி மற்றும் பணப்பைகள் மூலம் பாதுகாப்பான பணம் செலுத்துதல்.",
    "shSecureRazorpay": "பாதுகாப்பான Razorpay சாளரத்தில் நீங்கள் பணம் செலுத்துவீர்கள்.",
    "shSgst": "SGST ({rate}%)",
    "shShop": "ஷாப்பிங்",
    "shSignIn": "உள்நுழையுங்கள்",
    "shSignInToShop": "உங்கள் கார்டு, விருப்பப் பட்டியல் மற்றும் ஆர்டர்களைப் பார்க்க உள்நுழைக.",
    "shSkippedFree": "இது இப்போது இலவசம்: அதன் பக்கத்திலிருந்து பதிவு செய்யுங்கள்.",
    "shSkippedOwned": "நீங்கள் ஏற்கனவே இதை வைத்திருக்கிறீர்கள், எனவே அதற்கு கட்டணம் வசூலிக்கப்படாது.",
    "shStartCourse": "பாடத்திட்டத்தைத் தொடங்குங்கள்",
    "shStateRequired": "GST விலைப்பட்டியலுக்காக உங்கள் மாநிலத்தைத் (வழங்குவதற்கான இடம்) தேர்ந்தெடுக்கவும்.",
    "shStatusNote_cancelled": "இந்த ஆர்டர் ரத்து செய்யப்பட்டது மற்றும் உங்களிடம் கட்டணம் வசூலிக்கப்படவில்லை.",
    "shStatusNote_failed": "இந்த பணம் செலுத்துதல் தோல்வியடைந்தது மற்றும் உங்களிடம் கட்டணம் வசூலிக்கப்படவில்லை.",
    "shStatusNote_refunded": "இந்த ஆர்டர் திருப்பிச் செலுத்தப்பட்டது. பாடநெறி அணுகல் நீக்கப்பட்டுள்ளது.",
    "shStatus_cancelled": "ரத்து செய்யப்பட்டது",
    "shStatus_created": "பணம் செலுத்தும் பணி நிலுவையில் உள்ளது",
    "shStatus_failed": "பணம் செலுத்துவதில் தோல்வியுற்றது",
    "shStatus_paid": "செலுத்தப்பட்டது",
    "shStatus_refunded": "திருப்பிச் செலுத்தப்பட்டது",
    "shSubtotal": "துணை மொத்த",
    "shSummary": "ஆர்டர் சுருக்கம்",
    "shTaxInvoice": "வரி விலைப்பட்டியல்",
    "shTaxable": "வரி விதிக்கக்கூடிய மதிப்பு",
    "shTerms": "பணம் செலுத்துவதன் மூலம் நீங்கள் ஒப்புக்கொள்கிறீர்கள்",
    "shTermsLink": "சேவை விதிமுறைகள்",
    "shThanks": "நன்றி! உங்கள் பணம் வெற்றிகரமாக இருந்தது.",
    "shTotal": "மொத்த",
    "shTotalPaid": "மொத்த தொகை (GST உட்பட)",
    "shWishAdd": "விருப்பப் பட்டியலில் சேர்க்கவும்",
    "shWishEmpty": "உங்கள் விருப்பப் பட்டியல் காலியாக உள்ளது. அதை இங்கே சேமிக்க ஒரு பாதையில் உள்ள இதயத்தைத் தட்டவும்.",
    "shWishRemove": "விருப்பப் பட்டியலில் இருந்து நீக்கு",
    "shWishlist": "விருப்பப் பட்டியல்",
    "showOriginal": "அசல் காட்டவும்",
    "showTranslated": "{language} இல் காட்டு",
    "signIn": "உள்நுழையுங்கள்",
    "statAnytime": "எந்த நேரத்திலும் கற்றுக்கொள்ளுங்கள்",
    "statCourses": "படிப்புகள்",
    "statPartners": "பங்குதாரர் நிறுவனங்கள்",
    "subscribe": "சந்தா செலுத்துங்கள்",
    "tabAll": "அனைத்தும்",
    "tabNoCourses": "இந்த பிரிவில் இன்னும் படிப்புகள் எதுவும் இல்லை.",
    "terms": "சேவை விதிமுறைகள்",
    "toolsMenu": "ThervuMitra கருவிகள்: செயற்கை நுண்ணறிவு பாடத்திட்ட உருவாக்குநர், பகுப்பாய்வு, திட்டங்கள்",
    "topicLabel": "எங்களைப் பற்றி என்ன தொடர்பு கொள்கிறீர்கள்?",
    "topic_academia": "கல்வி நிறுவன விசாரணை",
    "topic_course": "பாடநெறி விசாரணை அல்லது ஒரு பாடத்திட்டத்தில் சேருதல்",
    "topic_feedback": "பின்னூட்டம்",
    "topic_other": "மற்றவை",
    "topic_partner": "கூட்டாண்மை அல்லது வணிக விசாரணை",
    "topic_teams": "அணிகளுக்கான பயிற்சி",
    "translationInProgress": "சில பகுதிகள் இன்னும் மொழிபெயர்க்கப்பட்டுள்ளன.",
    "trendingSubtitle": "புதிய படிப்புகளைப் படிக்கிறவர்கள் இப்போது தொடங்குகிறார்கள்.",
    "trendingTitle": "நமது போக்கு படிப்புகள்",
    "tutorBudget": "செயற்கை நுண்ணறிவு ஆசிரியர் இன்று ஓய்வெடுக்கிறார். தயவுசெய்து நாளை மீண்டும் முயற்சிக்கவும்.",
    "tutorCheckingProgress": "உங்கள் முன்னேற்றத்தை சரிபார்க்க...",
    "tutorDisclaimer": "செயற்கை நுண்ணறிவு பதில்கள் தவறாக இருக்கலாம். முக்கியமான எதற்கும் பாடத்திட்டப் பொருளைச் சரிபார்க்கவும்.",
    "tutorGreeting": "இந்தப் பாடத்திட்டத்திற்கு நான் உங்கள் ஆசிரியராக இருக்கிறேன். ஒரு தலைப்பை விளக்குங்கள், ஒரு அலகு சுருக்கமாக சொல்லுங்கள் அல்லது உங்கள் படிப்பைத் திட்டமிட உதவுங்கள்.",
    "tutorHelp1": "பாடத்திட்டத்தின் யோசனைகளை எளிய வார்த்தைகளில் விளக்குக",
    "tutorHelp2": "பாடத்திட்டத்தில் ஒரு தலைப்பு எங்கு உள்ளடக்கப்பட்டுள்ளது என்பதைக் கண்டறியவும்",
    "tutorHelp3": "ஒரு அலகு அல்லது ஒரு பகுதியை சுருக்கமாக குறிப்பிடுக",
    "tutorHelp4": "உங்கள் முன்னேற்றம் மற்றும் வரவிருக்கும் காலக்கெடுவை சரிபார்க்கவும்",
    "tutorHelpTitle": "நான் என்ன உதவ முடியும்",
    "tutorHonestyText": "தரப்படுத்தப்பட்ட கேள்விகளுக்கு நான் பதிலளிக்க மாட்டேன், ஆனால் அவற்றைப் புரிந்துகொள்ள நான் உங்களுக்கு உதவுவேன்.",
    "tutorHonestyTitle": "நேர்மையுடன் கற்றல்",
    "tutorIntro": "{course} பற்றி என்னிடம் ஏதேனும் கேளுங்கள். இந்த பாடத்திட்டத்தின் பொருட்களிலிருந்து நான் பதிலளிக்கிறேன்.",
    "tutorLoading": "உங்கள் ஆசிரியரை தயார் செய்து கொள்ளுங்கள்...",
    "tutorNotAllowed": "இந்த பாடத்திட்டத்தில் பதிவுசெய்யப்பட்ட மாணவர்களுக்கு செயற்கை நுண்ணறிவு ஆசிரியர் கிடைப்பார்.",
    "tutorPlaceholder": "இந்தப் படிப்பைப் பற்றிக் கேளுங்கள்.",
    "tutorReading": "பாடத்திட்டத்தைப் படி...",
    "tutorSuggest1": "இந்தப் பாடத்திட்டத்தின் முக்கிய யோசனைகள் யாவை?",
    "tutorSuggest2": "எனக்கு முதல் பகுதியை சுருக்கமாக சொல்லுங்கள்",
    "tutorSuggest3": "நான் எப்படி இருக்கிறேன், அடுத்து என்ன செய்ய வேண்டும்?",
    "tutorSuggest4": "கடினமான தலைப்பை எளிய வார்த்தைகளில் விளக்குக",
    "tutorTitle": "AI ஆசிரியர்",
    "tutorTryTitle": "கேட்க முயற்சிக்கவும்",
    "tutorUnavailable": "செயற்கை நுண்ணறிவு ஆசிரியர் இப்போது கிடைக்கவில்லை. தயவுசெய்து சிறிது நேரத்திற்குள் மீண்டும் முயற்சிக்கவும்.",
    "vdActivity": "செயல்பாடு",
    "vdActivityEmpty": "Vidya ஒரு பதிலில் வேலை செய்யும் போது, ஒவ்வொரு படியும் இங்கே தோன்றும்: சிந்தித்தல், தேடுதல், வினாடி வினாக்களை உருவாக்குதல் மற்றும் வரைதல்.",
    "vdAddedToBank": "உங்கள் தவறான வங்கியில் {n} சேர்க்கப்பட்டது",
    "vdAnotherQuiz": "மற்றொரு வினாடி வினா",
    "vdAnotherQuizPrompt": "{topic} இல் எனக்கு மற்றொரு வினாடி வினா கொடுங்கள், கொஞ்சம் கடினம்.",
    "vdAnswerLanguage": "மொழிக்கு பதில் சொல்லுங்கள்",
    "vdAnswerWas": "பதில்: {answer}",
    "vdAnsweredN": "{total} இன் {n} பதிலளித்தது",
    "vdAskAboutNote": "எனது குறிப்பைப் பற்றி \"{title}\": அதை நன்கு புரிந்துகொள்ள எனக்கு உதவுங்கள்.",
    "vdAskFollowUp": "பின்தொடர்தல் கேளுங்கள்",
    "vdBackToBank": "தவறாக வங்கிக்குத் திரும்பு",
    "vdBuiltFor": "இதற்காக கட்டப்பட்டது",
    "vdCardOf": "{total} இன் {n}",
    "vdChart": "விளக்கப்படம்",
    "vdChats": "அரட்டைகள்",
    "vdCheckAnswers": "பதில்களைச் சரிபார்க்கவும்",
    "vdCopied": "நகலெடுக்கப்பட்டது",
    "vdCopy": "நகலெடுக்கவும்",
    "vdCorrect": "சரி!",
    "vdCouldNotAdd": "உங்கள் கார்ட்டில் பாஸ் சேர்க்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
    "vdCouldNotDraw": "இந்த விளக்கப்படத்தை வரைய முடியவில்லை.",
    "vdCouldNotSave": "சேமிக்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
    "vdDelete": "நீக்கு",
    "vdDeleteChatConfirm": "இந்த அரட்டையை நீக்கவா?",
    "vdDeleteNoteConfirm": "இந்த குறிப்பை நீக்குமா?",
    "vdDiagram": "வரைபடம்",
    "vdDifficulty": "சிரமம்",
    "vdDisclaimer": "Vidya தவறுகள் செய்யலாம். அதிகாரப்பூர்வ ஆதாரங்களுடன் முக்கியமான உண்மைகளை சரிபார்க்கவும்.",
    "vdDrawing": "வரைதல்...",
    "vdDueN": "{n} மதிப்பாய்வுக்கு உள்ளது",
    "vdDueToday": "இன்று செலுத்த வேண்டிய",
    "vdError_allowance": "இன்றைய நியாயமான பயன்பாட்டு கொடுப்பனவை நீங்கள் பயன்படுத்தியுள்ளீர்கள். அது நாளை மறுதொடக்கம் செய்யப்படுகிறது.",
    "vdError_auth": "உங்கள் அமர்வு காலாவதியானது. தயவுசெய்து பக்கத்தை மீண்டும் ஏற்றவும்.",
    "vdError_budget": "Vidya இப்போது மிகவும் பிஸியாக உள்ளது. தயவுசெய்து சிறிது நேரத்தில் மீண்டும் முயற்சிக்கவும்.",
    "vdError_invalid": "அந்த செய்தியை அனுப்ப முடியவில்லை. தயவுசெய்து அதைச் சுருக்கவும், மீண்டும் முயற்சிக்கவும்.",
    "vdError_limit": "நீங்கள் மிக விரைவாக செய்திகளை அனுப்புகிறீர்கள். தயவுசெய்து சிறிது நேரம் காத்திருந்து மீண்டும் முயற்சிக்கவும்.",
    "vdError_unavailable": "Vidya இப்போது கிடைக்கவில்லை. தயவுசெய்து சிறிது நேரத்தில் மீண்டும் முயற்சிக்கவும்.",
    "vdExamDate": "தேர்வு தேதி",
    "vdExamStyle": "தேர்வு பாணி",
    "vdExplainMistakes": "எனது தவறுகளை விளக்குங்கள்",
    "vdExplainMistakesPrompt": "நான் வினாடி வினா போட்டியை {topic} என்ற இடத்தில் எடுத்தேன். இந்த கேள்விகளில் நான் எங்கே தவறு செய்தேன் என்பதையும், நான் திருத்த வேண்டிய கருத்துகளையும் விளக்குக:",
    "vdExtendPass": "பாஸ் நீட்டிப்பு",
    "vdExtendTitle": "உங்கள் Vidya பாஸ்-ஐ நீட்டிக்கவும்",
    "vdFact_fact": "உங்களைப் பற்றி",
    "vdFact_goal": "இலக்கு",
    "vdFact_preference": "முன்னுரிமை",
    "vdFact_strength": "வலுவாக",
    "vdFact_struggle": "கடினமாக உள்ளது",
    "vdFaqA3": "ஒவ்வொரு பாஸிலும் ஒரு நாளைக்கு சுமார் 150 செய்திகள் உள்ளன; ஆராய்ச்சி மற்றும் நீண்ட வினாடி வினாக்கள் இன்னும் கொஞ்சம் அதிகமாக உள்ளன. ஒவ்வொரு நாளும் கொடுப்பனவு மறுதொடக்கம் செய்யப்படுகிறது.",
    "vdFaqA4": "இல்லை. ஒரு பாஸ் அதன் காலத்திற்கு ஓடுகிறது மற்றும் முடிவடைகிறது. நீங்கள் விரும்பும் போதெல்லாம் மற்றொரு பாஸை வாங்குங்கள்; அது உங்கள் தற்போதைய பாஸ் முடிவடையும் போது தொடங்குகிறது.",
    "vdFaqA5": "Vidya மிகவும் திறமையானது, ஆனால் தவறுகளைச் செய்யலாம். அதை மாற்றும் உண்மைகளுக்கு இணையத்தில் தேடி ஆதாரங்களைக் காட்டுகிறது. உங்கள் பாடப்புத்தகங்கள் அல்லது அதிகாரப்பூர்வ ஆதாரங்களுக்கு எதிராக முக்கியமான எதையும் சரிபார்க்கவும்.",
    "vdFaqQ3": "நியாயமான பயன்பாடு என்றால் என்ன?",
    "vdFaqQ4": "எனது பாஸ் தானாகவே புதுப்பிக்கப்படுமா?",
    "vdFaqQ5": "பதில்களை நான் நம்ப முடியுமா?",
    "vdFaqTitle": "கேள்விகள்",
    "vdFeatText_ask": "அடிப்படைகள் முதல் மேம்பட்டவை வரை, எடுத்துக்காட்டுகள் மற்றும் புரிதலின் விரைவான சோதனைகளுடன் உங்கள் மட்டத்தில் தெளிவான விளக்கங்கள்.",
    "vdFeatText_mistakes": "ஒவ்வொரு தவறான பதிலும் சேமிக்கப்பட்டு, நீங்கள் அதை மாஸ்டர் செய்யும் வரை மதிப்பாய்வுக்கு திரும்பும்.",
    "vdFeatText_notebook": "பதில்கள், தீர்வுகள் மற்றும் வரைபடங்களை பின்னர் திருத்துவதற்கு சேமிக்கவும்.",
    "vdFeatText_profile": "உங்கள் தேர்வு, குறிக்கோள்கள் மற்றும் பலவீனமான தலைப்புகள் ஒவ்வொரு பதிலையும் வடிவமைக்கின்றன. Vidya நினைவில் வைத்திருப்பதை நீங்கள் பார்க்கலாம் மற்றும் திருத்தலாம்.",
    "vdFeatText_quiz": "எந்தவொரு தலைப்பு மற்றும் சிரமம் குறித்த தேர்வு பாணி கேள்விகள், விளக்கங்களுடன் உடனடியாக தரப்படுத்தப்படுகின்றன.",
    "vdFeatText_research": "மேற்கோள்கள், கண்ணோட்டங்கள் மற்றும் சமீபத்திய தரவுகளுடன் வலையில் இருந்து கட்டமைக்கப்பட்ட அறிக்கைகள்.",
    "vdFeatText_solve": "ஒவ்வொரு படிநிலையிலும் வேலை செய்த தீர்வுகள், சூத்திரம் மற்றும் அது ஏன் பொருந்தும், பதில் மற்றும் பொதுவான பொறியின் சரிபார்ப்பு.",
    "vdFeatText_visualize": "கடினமான தலைப்புகளை நினைவில் வைத்துக்கொள்வதை எளிதாக்கும் மன வரைபடங்கள், ஃப்ளோசார்ட்ஸ், காலவரிசை மற்றும் விளக்கப்படங்கள்.",
    "vdFeat_ask": "எதையாவது கேளுங்கள்",
    "vdFeat_mistakes": "வங்கி தவறாக",
    "vdFeat_notebook": "குறிப்பேடு",
    "vdFeat_profile": "உங்களை நினைவுபடுத்துகிறது",
    "vdFeat_quiz": "வினாடி வினாக்களைப் பயிற்சி செய்யுங்கள்",
    "vdFeat_research": "ஆதாரங்களுடன் ஆராய்ச்சி",
    "vdFeat_solve": "படிப்படியாகத் தீர்க்கவும்",
    "vdFeat_visualize": "காட்சிப்படுத்துங்கள்",
    "vdFeaturesTitle": "ஒரு ஆசிரியர், கற்றுக்கொள்ள பல வழிகள்",
    "vdFlashcards": "ஃப்ளாஷ்கார்டுகள்",
    "vdFlip": "ஃபிளிப் கார்டு",
    "vdForget": "மறந்து விடுங்கள்",
    "vdGetPass": "பாஸ் பெறுங்கள்",
    "vdGoals": "இலக்குகள்",
    "vdHow1": "உங்கள் இலக்கை Vidya சொல்லுங்கள்",
    "vdHow2": "உங்கள் வழியைக் கற்றுக் கொள்ளுங்கள்",
    "vdHow3": "உங்கள் இடைவெளிகளை சரிசெய்யவும்",
    "vdHowText1": "உங்கள் தேர்வு, தேதி மற்றும் நிலை, ஒரு முறை. Vidya அவற்றைச் சுற்றி திட்டமிடுகிறது.",
    "vdHowText2": "Vidya எடுக்கும் ஒவ்வொரு அடியையும் கேளுங்கள், தீர்க்கவும், வினாடி வினா, ஆராய்ச்சி அல்லது காட்சிப்படுத்தவும், பார்க்கவும்.",
    "vdHowText3": "தவறுகள் மதிப்பாய்வுக்கு மீண்டும் வருகின்றன, பலவீனமான தலைப்புகள் அதிக பயிற்சியைப் பெறுகின்றன.",
    "vdHowTitle": "இது எப்படி வேலை செய்கிறது?",
    "vdIGotIt": "எனக்கு அது கிடைத்தது",
    "vdIMissedIt": "நான் அதை தவறவிட்டேன்",
    "vdLevel": "நிலை",
    "vdLevelName_advanced": "மேம்பட்ட",
    "vdLevelName_beginner": "தொடக்கக்காரர்",
    "vdLevelName_intermediate": "இடைநிலை",
    "vdLevel_easy": "சுலபம்",
    "vdLevel_hard": "கடினம்",
    "vdLevel_medium": "நடுத்தர",
    "vdLevel_mixed": "கலவையான",
    "vdMarkYourself": "நீங்கள் சரியாக புரிந்துகொண்டீர்களா?",
    "vdMastered": "தேர்ச்சி பெற்றவர்",
    "vdMemory": "உங்களைப் பற்றி Vidya என்ன நினைவில் வைத்திருக்கிறது",
    "vdMemoryHelp": "Vidya நீங்கள் பகிர்ந்து கொள்ளும் இலக்குகள் மற்றும் உங்களுக்கு கடினமாகத் தோன்றும் தலைப்புகள் போன்ற நீடித்த விஷயங்களைக் குறிப்பிடுகிறது. நீங்கள் விரும்பும் எதையும் அகற்றுங்கள்.",
    "vdMenu": "மெனு",
    "vdMistakeBank": "வங்கி தவறாக",
    "vdMistakeHelp": "நீங்கள் தவறாகப் பெற்ற கேள்விகள் மதிப்பாய்வுக்குத் திரும்பும்: சரியான பதில்கள் அவற்றை மேலும் வெளியே கொண்டு செல்கின்றன, தவறானவை அவற்றை விரைவில் மீண்டும் கொண்டு வருகின்றன.",
    "vdMode": "முறை",
    "vdModeHelp_ask": "கருத்துக்கள், சந்தேகங்கள், சுருக்கங்கள், ஒப்பீடுகள்: உங்கள் மட்டத்தில் விளக்கப்பட்டுள்ளன.",
    "vdModeHelp_quiz": "ஒரு தலைப்புக்கு பெயரிட்டு, தேர்வு பாணி கேள்விகளை உடனடியாக தரவரிசைப்படுத்துங்கள். தவறான பதில்கள் உங்கள் தவறான வங்கிக்குச் செல்கின்றன.",
    "vdModeHelp_research": "Vidya இணையத்தில் தேடி ஆதாரங்களுடன் ஒரு கட்டமைக்கப்பட்ட அறிக்கையை எழுதுகிறது.",
    "vdModeHelp_visualize": "எந்தவொரு தலைப்புக்கும் மன வரைபடங்கள், ஓட்ட விளக்கப்படங்கள், காலவரிசை மற்றும் விளக்கப்படங்கள்.",
    "vdModeTitle_ask": "Vidya எதையாவது கேளுங்கள்",
    "vdModeTitle_quiz": "வினாடி வினா மூலம் பயிற்சி செய்யுங்கள்",
    "vdModeTitle_research": "ஒரு தலைப்பை ஆராய்ச்சி செய்யுங்கள்",
    "vdModeTitle_solve": "படிப்படியாக ஒரு சிக்கலைத் தீர்க்கவும்",
    "vdModeTitle_visualize": "பார்வைக்கு பாருங்கள்",
    "vdMode_ask": "கேளுங்கள்",
    "vdMode_quiz": "வினாடி வினா",
    "vdMode_research": "ஆராய்ச்சி",
    "vdMode_solve": "தீர்க்கவும்",
    "vdMode_visualize": "காட்சிப்படுத்துங்கள்",
    "vdModelAnswer": "மாதிரி பதில்:",
    "vdMyAnswer": "எனது பதில்: {given}",
    "vdMyProfile": "எனது சுயவிவரம்",
    "vdNav": "Vidya AI",
    "vdNewChat": "புதிய அரட்டை",
    "vdNext": "அடுத்து",
    "vdNextReview": "அடுத்த மதிப்பாய்வு {date}",
    "vdNoChats": "இன்னும் அரட்டைகள் இல்லை.",
    "vdNoMemory": "இன்னும் எதுவும் இல்லை. Vidya நீங்கள் அரட்டையடிக்கும்போது உங்கள் இலக்குகள் போன்ற விஷயங்களை நினைவில் வைத்திருக்கும்.",
    "vdNoMistakes": "இதுவரை எந்தத் தவறுகளும் சேமிக்கப்படவில்லை. வினாடி வினா எடுக்கவும், ஏதேனும் தவறான பதில்கள் இருந்தால் இங்கே தோன்றும்.",
    "vdNoNotes": "இன்னும் எதுவும் சேமிக்கப்படவில்லை. எந்த பதிலும் இருந்தால் \"சேமிக்கவும்\" என்ற குறிப்பாணையைப் பயன்படுத்தவும்.",
    "vdNoPlans": "Vidya பாஸ் இப்போது விற்பனைக்கு இல்லை. தயவுசெய்து விரைவில் சரிபார்க்கவும்.",
    "vdNotSet": "அமைக்கப்படவில்லை",
    "vdNote": "குறிப்பு",
    "vdNotebook": "குறிப்பேடு",
    "vdNotebookHelp": "நீங்கள் சேமித்த பதில்கள், தீர்வுகள் மற்றும் வரைபடங்கள், எந்த நேரத்திலும் திருத்துவதற்கு.",
    "vdOpenMistakes": "மாஸ்டர் செய்ய",
    "vdOpenVidya": "Vidya ஐத் திறக்கவும்",
    "vdOther": "மற்றவை",
    "vdPassUntil": "{date} வரை செயலில் உள்ள பாஸ்",
    "vdPaymentsOff": "ஆன்லைன் கட்டணங்கள் அமைக்கப்பட்டு வருகின்றன. தயவுசெய்து பின்னர் மீண்டும் முயற்சிக்கவும்.",
    "vdPerMonth": "மாதத்திற்கு",
    "vdPerMonthEquiv": "ஒரு மாதத்திற்கு வெறும் ₹ {price}",
    "vdPerYear": "ஆண்டுக்கு",
    "vdPin": "பின் அரட்டை",
    "vdPlanAll": "அனைத்து முறைகளும்: கேளுங்கள், தீர்க்கவும், வினாடி வினா, ஆராய்ச்சி, காட்சிப்படுத்தவும்",
    "vdPlanFair": "ஒரு நாளைக்கு சுமார் 150 செய்திகள் (நியாயமான பயன்பாடு)",
    "vdPlanGst": "விலையிலும் ஜி. எஸ். டி. அடங்கும், இதில் வரி விலைப்பட்டியலும் அடங்கும்",
    "vdPlanMonth": "1 மாதம்",
    "vdPlanYear": "1 ஆண்டு",
    "vdPlansText": "ஒரு முறை பணம் செலுத்துதல், தானாக புதுப்பித்தல் இல்லை. உங்கள் தற்போதைய இறுதி தேதியிலிருந்து நீட்டிக்க எந்த நேரத்திலும் மீண்டும் வாங்கவும்.",
    "vdPlansTitle": "உங்கள் Vidya பாஸ் பெறவும்",
    "vdPracticeWeak": "எனது பலவீனமான தலைப்புகளைப் பயிற்சி செய்யுங்கள்",
    "vdPracticeWeakPrompt": "எனது பலவீனமான தலைப்புகள் குறித்து ஒரு திருத்த வினாடி வினா கொடுங்கள்: {topics}.",
    "vdPrev": "முந்தைய",
    "vdPreviewA": "சட்டத்தால் நிறுவப்பட்ட நடைமுறையின் மூலம் தவிர எந்தவொரு நபரும் வாழ்க்கை அல்லது தனிப்பட்ட சுதந்திரத்தை இழக்க மாட்டார். உச்ச நீதிமன்றம் அதை பரவலாக வாசித்துள்ளது...",
    "vdPreviewQ": "பிரிவு 21ஐ ஒரு விரைவான வினாடி வினா மூலம் விளக்குக",
    "vdPreviewTitle": "பிரிவு 21: உயிர் மற்றும் தனிப்பட்ட சுதந்திரத்தைப் பாதுகாத்தல்",
    "vdProfileHelp": "Vidya ஒவ்வொரு பதிலையும் வடிவமைக்க இதைப் பயன்படுத்துகிறது. நீங்களும் Vidya-ம் மட்டுமே அதைப் பார்க்க முடியும்.",
    "vdQuestions": "கேள்விகள்",
    "vdQuestionsN": "{n} கேள்விகள்",
    "vdQuiz": "வினாடி வினா",
    "vdQuizMe": "இது குறித்து எனக்கு கேள்வி கேளுங்கள்",
    "vdQuizMeOnNote": "எனது குறிப்பில் \"{title}\" என்று எனக்கு வினாடி வினா அளியுங்கள்.",
    "vdRemove": "அகற்றவும்",
    "vdResearch": "ஆராய்ச்சி",
    "vdReviewDone": "மதிப்பாய்வு முடிந்தது",
    "vdReviewDue": "இப்போது {n} ஐ மதிப்பாய்வு செய்யுங்கள்",
    "vdReviewScore": "உங்களுக்கு {total} இன் {n} கிடைத்தது.",
    "vdSave": "சேமி",
    "vdSaveToNotebook": "குறிப்பேடில் சேமிக்கவும்",
    "vdSave_pct": "{pct}% ஐச் சேமிக்கவும்",
    "vdSaved": "சேமித்த",
    "vdSavedToNotebook": "உங்கள் நோட்டுப் புத்தகத்தில் சேமிக்கப்படுகிறது",
    "vdScore": "மதிப்பெண்: {score} {total}",
    "vdSearchChats": "அரட்டைகளைத் தேடுங்கள்",
    "vdSearchNotes": "குறிப்புகளைத் தேடுங்கள்",
    "vdSeePlans": "திட்டங்களை பாருங்கள்",
    "vdSend": "அனுப்பவும்",
    "vdShowAnswer": "பதிலைக் காட்டு",
    "vdShuffle": "மாற்றவும்",
    "vdSiteLanguage": "தளத்தைப் போலவே",
    "vdSources": "ஆதாரங்கள்",
    "vdStarting": "தொடக்கம்...",
    "vdStatAccuracy": "வினாடி வினா துல்லியம்",
    "vdStatDays": "செயல்பாட்டு நாட்கள்",
    "vdStatQuestions": "கேட்கப்பட்ட கேள்விகள்",
    "vdStatQuizzes": "வினாடி வினாக்கள் எடுக்கப்பட்டன",
    "vdState_done": "முடிந்தது",
    "vdState_error": "தோல்வியடைந்தார்",
    "vdState_running": "நடந்து வருகிறது",
    "vdStop": "நிறுத்துங்கள்",
    "vdStyle": "பதில் பாணி",
    "vdStyle_concise": "குறுகிய மற்றும் புள்ளி",
    "vdStyle_detailed": "விவரம்",
    "vdStyle_socratic": "கேள்விகளுடன் எனக்கு வழிகாட்டுங்கள்",
    "vdThinking": "Vidya யோசித்து கொண்டிருக்கிறார்...",
    "vdTitle": "Vidya",
    "vdTool_get_my_mistakes": "உங்கள் வங்கி தவறை சரிபார்க்கவும்",
    "vdTool_remember": "உங்கள் சுயவிவரத்தைப் புதுப்பிக்கவும்",
    "vdTool_show_chart": "ஒரு விளக்கப்படத்தை வரைவதற்கு",
    "vdTool_show_diagram": "ஒரு வரைபடத்தை வரைவதற்கு",
    "vdTool_show_flashcards": "ஃபிளாஷ்கார்டுகள் தயாரித்தல்",
    "vdTool_show_quiz": "வினாடி வினா ஒன்றை உருவாக்குவது",
    "vdTool_think": "யோசித்து",
    "vdTool_web_search": "இணையத்தில் தேடி",
    "vdUnpin": "அரட்டை முத்திரையை நீக்கு",
    "vdUntitled": "பெயரிடப்படாத அரட்டை",
    "vdUsage": "இன்றைய நியாயமான பயன்பாட்டு கொடுப்பனவின் {pct}% பயன்படுத்தப்படுகிறது",
    "vdWeakCounts": "{misses} தவறு · {hits} சரி",
    "vdWeakTopics": "பலவீனமான தலைப்புகள் (உங்கள் வினாடி வினாக்களிலிருந்து)",
    "vdYouAnsweredBefore": "முன்னதாக நீங்கள் பதிலளித்தது: {given}",
    "vdYourAnswer": "உங்கள் பதில்",
    "viewAll": "அனைத்து படிப்புகளையும் பார்க்கவும்",
    "viewCourse": "பாடத்திட்டத்தைக் காண்க",
    "welcome": "ThervuMitra, {name} க்கு வரவேற்கிறோம்.",
    "welcomeAnonymous": "ThervuMitra க்கு வரவேற்கிறேன்.",
    "whyTitle": "ThervuMitra மூலம் ஏன் கற்றுக்கொள்ள வேண்டும்?"
  }
};
